import type { BreedSchema, CrossBreedSchema } from '../types/breed';

export const BaseCrossBreedList: BreedSchema[] = [
  { id: '4', type: 'dog', breedName: 'Small cross-breed (up to 10kg)', isCrossBreed: true, isBaseCrossBreed: true },
  { id: '5', type: 'dog', breedName: 'Medium cross-breed (10 - 20kg)', isCrossBreed: true, isBaseCrossBreed: true },
  { id: '6', type: 'dog', breedName: 'Large cross-breed (more than 20kg)', isCrossBreed: true, isBaseCrossBreed: true },
];

export const CrossBreedList: CrossBreedSchema[] = [
  {
    aliasToBreedId: '6',
    breedName: 'Afaird',
    type: 'dog',
    id: 'Cross-1',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afador',
    type: 'dog',
    id: 'Cross-2',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Affen Spaniel',
    type: 'dog',
    id: 'Cross-3',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affen Border Terrier',
    type: 'dog',
    id: 'Cross-4',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affen Tzu',
    type: 'dog',
    id: 'Cross-5',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affenchon',
    type: 'dog',
    id: 'Cross-6',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affengriffon',
    type: 'dog',
    id: 'Cross-7',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affenhuahua',
    type: 'dog',
    id: 'Cross-8',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Affenpoo',
    type: 'dog',
    id: 'Cross-9',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affenpug',
    type: 'dog',
    id: 'Cross-10',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affenshire',
    type: 'dog',
    id: 'Cross-11',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Affenwich',
    type: 'dog',
    id: 'Cross-12',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afghan Bay Retriever',
    type: 'dog',
    id: 'Cross-13',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afghan Chon',
    type: 'dog',
    id: 'Cross-14',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afghan Collie',
    type: 'dog',
    id: 'Cross-15',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afghan Retriever',
    type: 'dog',
    id: 'Cross-16',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afghan Sheepdog',
    type: 'dog',
    id: 'Cross-17',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afghan Spaniel',
    type: 'dog',
    id: 'Cross-18',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Afollie',
    type: 'dog',
    id: 'Cross-19',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'African-American Bull Boerboel',
    type: 'dog',
    id: 'Cross-20',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Airedale Shepherd',
    type: 'dog',
    id: 'Cross-21',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Airedoodle',
    type: 'dog',
    id: 'Cross-22',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Akbash Pyrenees',
    type: 'dog',
    id: 'Cross-23',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Akbash Rottie',
    type: 'dog',
    id: 'Cross-24',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aki-Poo',
    type: 'dog',
    id: 'Cross-25',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Akita Basset',
    type: 'dog',
    id: 'Cross-26',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Akita Bernard',
    type: 'dog',
    id: 'Cross-27',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Akita Chow',
    type: 'dog',
    id: 'Cross-28',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Akita Pit',
    type: 'dog',
    id: 'Cross-29',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Akita Shepherd',
    type: 'dog',
    id: 'Cross-30',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Akitamatian',
    type: 'dog',
    id: 'Cross-31',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alaskan Goldenmute',
    type: 'dog',
    id: 'Cross-32',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alaskan Husky Shepherd',
    type: 'dog',
    id: 'Cross-33',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alaskan Irish Setsky',
    type: 'dog',
    id: 'Cross-34',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alaskan Malador',
    type: 'dog',
    id: 'Cross-35',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Alaskan Pit Bull',
    type: 'dog',
    id: 'Cross-36',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alaskan Shepherd',
    type: 'dog',
    id: 'Cross-37',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alaskan Weimsky',
    type: 'dog',
    id: 'Cross-38',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Alusky',
    type: 'dog',
    id: 'Cross-39',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bandogge',
    type: 'dog',
    id: 'Cross-40',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'American Boston Bull Terrier',
    type: 'dog',
    id: 'Cross-41',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Boxer Foxhound',
    type: 'dog',
    id: 'Cross-42',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bull-Aussie',
    type: 'dog',
    id: 'Cross-43',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bull Dogue De Bordeaux',
    type: 'dog',
    id: 'Cross-44',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bull-Jack',
    type: 'dog',
    id: 'Cross-45',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bull Pei',
    type: 'dog',
    id: 'Cross-46',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'American Bull Staffy',
    type: 'dog',
    id: 'Cross-47',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bullador',
    type: 'dog',
    id: 'Cross-48',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bulldog Shepherd',
    type: 'dog',
    id: 'Cross-49',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bullhuahua',
    type: 'dog',
    id: 'Cross-50',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bullweiler',
    type: 'dog',
    id: 'Cross-51',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bull Dane',
    type: 'dog',
    id: 'Cross-52',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Bully Staffy Bull Terrier',
    type: 'dog',
    id: 'Cross-53',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Chow Bulldog',
    type: 'dog',
    id: 'Cross-54',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'American Eagle Dog',
    type: 'dog',
    id: 'Cross-55',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Foxeagle',
    type: 'dog',
    id: 'Cross-56',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Foxy Dane',
    type: 'dog',
    id: 'Cross-57',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'American French Bull Terrier',
    type: 'dog',
    id: 'Cross-58',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American French Bulldog',
    type: 'dog',
    id: 'Cross-59',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Gointer',
    type: 'dog',
    id: 'Cross-60',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'American Hairless Min Pin',
    type: 'dog',
    id: 'Cross-61',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Lab Foxhound',
    type: 'dog',
    id: 'Cross-62',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Masti-Bull',
    type: 'dog',
    id: 'Cross-63',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Neo Bull',
    type: 'dog',
    id: 'Cross-64',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'American Pit Corso',
    type: 'dog',
    id: 'Cross-65',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'American Pugabull',
    type: 'dog',
    id: 'Cross-66',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'American Rat Pinscher',
    type: 'dog',
    id: 'Cross-67',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'American Staffy Bullmastiff',
    type: 'dog',
    id: 'Cross-68',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Amstiff',
    type: 'dog',
    id: 'Cross-69',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Anatolian Pyrenees',
    type: 'dog',
    id: 'Cross-70',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Ausahoula',
    type: 'dog',
    id: 'Cross-71',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Ausky',
    type: 'dog',
    id: 'Cross-72',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Auss-Tzu',
    type: 'dog',
    id: 'Cross-73',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussalier',
    type: 'dog',
    id: 'Cross-74',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Brittany',
    type: 'dog',
    id: 'Cross-75',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie-Chi',
    type: 'dog',
    id: 'Cross-76',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Collie',
    type: 'dog',
    id: 'Cross-77',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie-Corgi',
    type: 'dog',
    id: 'Cross-78',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie-Flat',
    type: 'dog',
    id: 'Cross-79',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Jack',
    type: 'dog',
    id: 'Cross-80',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Malamute',
    type: 'dog',
    id: 'Cross-81',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Newfie',
    type: 'dog',
    id: 'Cross-82',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Pom',
    type: 'dog',
    id: 'Cross-83',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Rottie',
    type: 'dog',
    id: 'Cross-84',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Shiba',
    type: 'dog',
    id: 'Cross-85',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Siberian',
    type: 'dog',
    id: 'Cross-86',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Aussie Silk Terrier',
    type: 'dog',
    id: 'Cross-87',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Springer',
    type: 'dog',
    id: 'Cross-88',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussie Wheaten',
    type: 'dog',
    id: 'Cross-89',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussietare',
    type: 'dog',
    id: 'Cross-90',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussiedoodle',
    type: 'dog',
    id: 'Cross-91',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Aussiedor',
    type: 'dog',
    id: 'Cross-92',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Aussimo',
    type: 'dog',
    id: 'Cross-93',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Austi-Pap',
    type: 'dog',
    id: 'Cross-94',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Australian Boxherd',
    type: 'dog',
    id: 'Cross-95',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Australian Eskimo',
    type: 'dog',
    id: 'Cross-96',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Australian Retriever',
    type: 'dog',
    id: 'Cross-97',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Australian Yorkshire Terrier',
    type: 'dog',
    id: 'Cross-98',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Azawakh Borzoi',
    type: 'dog',
    id: 'Cross-99',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Ba-Shar',
    type: 'dog',
    id: 'Cross-100',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bagle Hound',
    type: 'dog',
    id: 'Cross-101',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Balonkatese',
    type: 'dog',
    id: 'Cross-102',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bascottie',
    type: 'dog',
    id: 'Cross-103',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Baseagle',
    type: 'dog',
    id: 'Cross-104',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Basenji Pit',
    type: 'dog',
    id: 'Cross-105',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Baskimo',
    type: 'dog',
    id: 'Cross-106',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bassador',
    type: 'dog',
    id: 'Cross-107',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basschshund',
    type: 'dog',
    id: 'Cross-108',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basselier',
    type: 'dog',
    id: 'Cross-109',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Bluetick',
    type: 'dog',
    id: 'Cross-110',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Bordeaux',
    type: 'dog',
    id: 'Cross-111',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Foxhound',
    type: 'dog',
    id: 'Cross-112',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Heeler',
    type: 'dog',
    id: 'Cross-113',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Jack',
    type: 'dog',
    id: 'Cross-114',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Retriever',
    type: 'dog',
    id: 'Cross-115',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basset Shepherd',
    type: 'dog',
    id: 'Cross-116',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bassetoodle',
    type: 'dog',
    id: 'Cross-117',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bassky',
    type: 'dog',
    id: 'Cross-118',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bassmatian',
    type: 'dog',
    id: 'Cross-119',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Basston',
    type: 'dog',
    id: 'Cross-120',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bassugg',
    type: 'dog',
    id: 'Cross-121',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'BD Terrier',
    type: 'dog',
    id: 'Cross-122',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Be-Apso',
    type: 'dog',
    id: 'Cross-123',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bea Griffon',
    type: 'dog',
    id: 'Cross-124',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bea-Tzu',
    type: 'dog',
    id: 'Cross-125',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beabull',
    type: 'dog',
    id: 'Cross-126',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beacol',
    type: 'dog',
    id: 'Cross-127',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Beagi',
    type: 'dog',
    id: 'Cross-128',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beagleman',
    type: 'dog',
    id: 'Cross-129',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beaglemation',
    type: 'dog',
    id: 'Cross-130',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Beagle Chin',
    type: 'dog',
    id: 'Cross-131',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Beagle Heeler',
    type: 'dog',
    id: 'Cross-132',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Beagle Pit',
    type: 'dog',
    id: 'Cross-133',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beagle Point',
    type: 'dog',
    id: 'Cross-134',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Beagle Sheltie',
    type: 'dog',
    id: 'Cross-135',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beagle Shepherd',
    type: 'dog',
    id: 'Cross-136',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Beaglier',
    type: 'dog',
    id: 'Cross-137',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Beaglolo',
    type: 'dog',
    id: 'Cross-138',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beago',
    type: 'dog',
    id: 'Cross-139',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beardoodle',
    type: 'dog',
    id: 'Cross-140',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beaski',
    type: 'dog',
    id: 'Cross-141',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Beauceroodle',
    type: 'dog',
    id: 'Cross-142',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bebasset Bordeaux',
    type: 'dog',
    id: 'Cross-143',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bedlington Whippet',
    type: 'dog',
    id: 'Cross-144',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Belgian Shepadoodle',
    type: 'dog',
    id: 'Cross-145',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Belusky',
    type: 'dog',
    id: 'Cross-146',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bernedoodle',
    type: 'dog',
    id: 'Cross-147',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bernefie',
    type: 'dog',
    id: 'Cross-148',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Berner Chow',
    type: 'dog',
    id: 'Cross-149',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Berner Dane',
    type: 'dog',
    id: 'Cross-150',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bernese Cattle Dog',
    type: 'dog',
    id: 'Cross-151',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bernese Rottie',
    type: 'dog',
    id: 'Cross-152',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bich-poo',
    type: 'dog',
    id: 'Cross-153',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Bichomo',
    type: 'dog',
    id: 'Cross-154',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bichon-A-Ranian',
    type: 'dog',
    id: 'Cross-155',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bichon Yorkie',
    type: 'dog',
    id: 'Cross-156',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Biton',
    type: 'dog',
    id: 'Cross-157',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Black and Tan Coonoodle',
    type: 'dog',
    id: 'Cross-158',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Black and Tan Coonshepherd',
    type: 'dog',
    id: 'Cross-159',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Black and Tan Labhound',
    type: 'dog',
    id: 'Cross-160',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Black Mouth Pom Cur',
    type: 'dog',
    id: 'Cross-161',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Black Russian Wolfhound Terrier',
    type: 'dog',
    id: 'Cross-162',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bloodahouli',
    type: 'dog',
    id: 'Cross-163',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Blue Blood Cane Corso',
    type: 'dog',
    id: 'Cross-164',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Blue Spaniel',
    type: 'dog',
    id: 'Cross-165',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Blue-Tzu Heeler',
    type: 'dog',
    id: 'Cross-166',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bluetick Coonoodle',
    type: 'dog',
    id: 'Cross-167',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bluetick Coonhound Harrier',
    type: 'dog',
    id: 'Cross-168',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bluetick Rat Terrier',
    type: 'dog',
    id: 'Cross-169',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bluetick Walker',
    type: 'dog',
    id: 'Cross-170',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bo-Dach',
    type: 'dog',
    id: 'Cross-171',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bo-Jack',
    type: 'dog',
    id: 'Cross-172',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Bocker',
    type: 'dog',
    id: 'Cross-173',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bodacion',
    type: 'dog',
    id: 'Cross-174',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Boerboel Bernard',
    type: 'dog',
    id: 'Cross-175',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Boerboel Pei',
    type: 'dog',
    id: 'Cross-176',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Boerboel Pit',
    type: 'dog',
    id: 'Cross-177',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Boglen Terrier',
    type: 'dog',
    id: 'Cross-178',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bogle',
    type: 'dog',
    id: 'Cross-179',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bolo-chi',
    type: 'dog',
    id: 'Cross-180',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bolo-Tzu',
    type: 'dog',
    id: 'Cross-181',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Bologco',
    type: 'dog',
    id: 'Cross-182',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bololgnese Bolonka',
    type: 'dog',
    id: 'Cross-183',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bolonauzer',
    type: 'dog',
    id: 'Cross-184',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bolonoodle',
    type: 'dog',
    id: 'Cross-185',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bolosilk',
    type: 'dog',
    id: 'Cross-186',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Borador',
    type: 'dog',
    id: 'Cross-187',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bordeaux Pitbull',
    type: 'dog',
    id: 'Cross-188',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Border Akbash Collie',
    type: 'dog',
    id: 'Cross-189',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Akita Collie',
    type: 'dog',
    id: 'Cross-190',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border-Aussie',
    type: 'dog',
    id: 'Cross-191',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Aussie Terrollie',
    type: 'dog',
    id: 'Cross-192',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Basset',
    type: 'dog',
    id: 'Cross-193',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Beagle',
    type: 'dog',
    id: 'Cross-194',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Bluetick Collie',
    type: 'dog',
    id: 'Cross-195',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Chow',
    type: 'dog',
    id: 'Cross-196',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Collie Bernard',
    type: 'dog',
    id: 'Cross-197',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Collie Britt',
    type: 'dog',
    id: 'Cross-198',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Collie Bull Staffy',
    type: 'dog',
    id: 'Cross-199',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Collie Cocker',
    type: 'dog',
    id: 'Cross-200',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Collie Lakeland',
    type: 'dog',
    id: 'Cross-201',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Border Collie Pit',
    type: 'dog',
    id: 'Cross-202',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Border Collie Pyrenees',
    type: 'dog',
    id: 'Cross-203',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Heeler',
    type: 'dog',
    id: 'Cross-204',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Jack',
    type: 'dog',
    id: 'Cross-205',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Kelpie',
    type: 'dog',
    id: 'Cross-206',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Malamute Collie',
    type: 'dog',
    id: 'Cross-207',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Malamute Terrier',
    type: 'dog',
    id: 'Cross-208',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Newfie',
    type: 'dog',
    id: 'Cross-209',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Point',
    type: 'dog',
    id: 'Cross-210',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Pom',
    type: 'dog',
    id: 'Cross-211',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Rottie',
    type: 'dog',
    id: 'Cross-212',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Schnollie',
    type: 'dog',
    id: 'Cross-213',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Sheepdog',
    type: 'dog',
    id: 'Cross-214',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Border Springer',
    type: 'dog',
    id: 'Cross-215',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Stack',
    type: 'dog',
    id: 'Cross-216',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Border Whipollie',
    type: 'dog',
    id: 'Cross-217',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bordernese',
    type: 'dog',
    id: 'Cross-218',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bordoodle',
    type: 'dog',
    id: 'Cross-219',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Borgi',
    type: 'dog',
    id: 'Cross-220',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Borollie',
    type: 'dog',
    id: 'Cross-221',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bosapso',
    type: 'dog',
    id: 'Cross-222',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'BoShih',
    type: 'dog',
    id: 'Cross-223',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Boskimo',
    type: 'dog',
    id: 'Cross-224',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bosmaraner',
    type: 'dog',
    id: 'Cross-225',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bospin',
    type: 'dog',
    id: 'Cross-226',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bossi-Poo',
    type: 'dog',
    id: 'Cross-227',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bossie',
    type: 'dog',
    id: 'Cross-228',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bostalian',
    type: 'dog',
    id: 'Cross-229',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bostchon',
    type: 'dog',
    id: 'Cross-230',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bostie',
    type: 'dog',
    id: 'Cross-231',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bostillon',
    type: 'dog',
    id: 'Cross-232',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bostinese',
    type: 'dog',
    id: 'Cross-233',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Boston Border Collie',
    type: 'dog',
    id: 'Cross-234',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boston Boxer',
    type: 'dog',
    id: 'Cross-235',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Boston Cattle Dog',
    type: 'dog',
    id: 'Cross-236',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Boston Chin',
    type: 'dog',
    id: 'Cross-237',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Boston Huahua',
    type: 'dog',
    id: 'Cross-238',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Boston Iggy',
    type: 'dog',
    id: 'Cross-239',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boston Lab',
    type: 'dog',
    id: 'Cross-240',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Boston Malterrier',
    type: 'dog',
    id: 'Cross-241',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boston Mastiff Terrier',
    type: 'dog',
    id: 'Cross-242',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Boston Spaniel',
    type: 'dog',
    id: 'Cross-243',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Boston Yorkie',
    type: 'dog',
    id: 'Cross-244',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bouberman',
    type: 'dog',
    id: 'Cross-245',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bouvador',
    type: 'dog',
    id: 'Cross-246',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boweimar',
    type: 'dog',
    id: 'Cross-247',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bowzer',
    type: 'dog',
    id: 'Cross-248',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Box-a-Pug',
    type: 'dog',
    id: 'Cross-249',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Box-a-Shar',
    type: 'dog',
    id: 'Cross-250',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Box Heeler',
    type: 'dog',
    id: 'Cross-251',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxer Bloodhound',
    type: 'dog',
    id: 'Cross-252',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxer Chow',
    type: 'dog',
    id: 'Cross-253',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxer Jack',
    type: 'dog',
    id: 'Cross-254',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxer Shepherd',
    type: 'dog',
    id: 'Cross-255',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxer Whippet',
    type: 'dog',
    id: 'Cross-256',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxachi',
    type: 'dog',
    id: 'Cross-257',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxador',
    type: 'dog',
    id: 'Cross-258',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxane',
    type: 'dog',
    id: 'Cross-259',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxapoint',
    type: 'dog',
    id: 'Cross-260',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxer Basset',
    type: 'dog',
    id: 'Cross-261',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxerdoodle',
    type: 'dog',
    id: 'Cross-262',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxerman',
    type: 'dog',
    id: 'Cross-263',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxita',
    type: 'dog',
    id: 'Cross-264',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxmas',
    type: 'dog',
    id: 'Cross-265',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxmatian',
    type: 'dog',
    id: 'Cross-266',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxollie',
    type: 'dog',
    id: 'Cross-267',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxsky',
    type: 'dog',
    id: 'Cross-268',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxspring',
    type: 'dog',
    id: 'Cross-269',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Boxweiler',
    type: 'dog',
    id: 'Cross-270',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Brat',
    type: 'dog',
    id: 'Cross-271',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bridoodle',
    type: 'dog',
    id: 'Cross-272',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Brittany Beagle',
    type: 'dog',
    id: 'Cross-273',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Brittany Bourbonnais',
    type: 'dog',
    id: 'Cross-274',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Brittnepoo',
    type: 'dog',
    id: 'Cross-275',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Broholmer Pit',
    type: 'dog',
    id: 'Cross-276',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Broodle Griffon',
    type: 'dog',
    id: 'Cross-277',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Brottweiler',
    type: 'dog',
    id: 'Cross-278',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Brug',
    type: 'dog',
    id: 'Cross-279',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Brussalier',
    type: 'dog',
    id: 'Cross-280',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Brusselranian',
    type: 'dog',
    id: 'Cross-281',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Brusston',
    type: 'dog',
    id: 'Cross-282',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'BT Walker',
    type: 'dog',
    id: 'Cross-283',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Buggs',
    type: 'dog',
    id: 'Cross-284',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull-Aussie',
    type: 'dog',
    id: 'Cross-285',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull-Boxer',
    type: 'dog',
    id: 'Cross-286',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull Chow Terrier',
    type: 'dog',
    id: 'Cross-287',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull Daniff',
    type: 'dog',
    id: 'Cross-288',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull Greyhound Terrier',
    type: 'dog',
    id: 'Cross-289',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull Heeler Terrier',
    type: 'dog',
    id: 'Cross-290',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull Jack',
    type: 'dog',
    id: 'Cross-291',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull Mastweiler',
    type: 'dog',
    id: 'Cross-292',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bull-Pei',
    type: 'dog',
    id: 'Cross-293',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullador',
    type: 'dog',
    id: 'Cross-294',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullbasset Mastiff',
    type: 'dog',
    id: 'Cross-295',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bullboxer Pit',
    type: 'dog',
    id: 'Cross-296',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bullboxer Staff',
    type: 'dog',
    id: 'Cross-297',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullboxer Staffy Bull',
    type: 'dog',
    id: 'Cross-298',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bulldog Schnauzer',
    type: 'dog',
    id: 'Cross-299',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullhuahua',
    type: 'dog',
    id: 'Cross-300',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullhuahua Terrier',
    type: 'dog',
    id: 'Cross-301',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullkita',
    type: 'dog',
    id: 'Cross-302',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullmasador',
    type: 'dog',
    id: 'Cross-303',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullmastiff Shepherd',
    type: 'dog',
    id: 'Cross-304',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullmatian',
    type: 'dog',
    id: 'Cross-305',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullmatian Terrier',
    type: 'dog',
    id: 'Cross-306',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bulloxer',
    type: 'dog',
    id: 'Cross-307',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullsky Mastiff',
    type: 'dog',
    id: 'Cross-308',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bullwhip',
    type: 'dog',
    id: 'Cross-309',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bully Basset',
    type: 'dog',
    id: 'Cross-310',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bully Bordeaux',
    type: 'dog',
    id: 'Cross-311',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bully Chi',
    type: 'dog',
    id: 'Cross-312',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bully Kutta Lab',
    type: 'dog',
    id: 'Cross-313',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bully Jack Terrier',
    type: 'dog',
    id: 'Cross-314',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bully Pitsky',
    type: 'dog',
    id: 'Cross-315',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bully-Tzu',
    type: 'dog',
    id: 'Cross-316',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Bully Wheaten',
    type: 'dog',
    id: 'Cross-317',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Bullypit',
    type: 'dog',
    id: 'Cross-318',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Bushland Terrier',
    type: 'dog',
    id: 'Cross-319',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cadoodle',
    type: 'dog',
    id: 'Cross-320',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairanian',
    type: 'dog',
    id: 'Cross-321',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cairicocker',
    type: 'dog',
    id: 'Cross-322',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairland Terrier',
    type: 'dog',
    id: 'Cross-323',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairmal',
    type: 'dog',
    id: 'Cross-324',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairn Beagle',
    type: 'dog',
    id: 'Cross-325',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairn Chin',
    type: 'dog',
    id: 'Cross-326',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Carin Australian Shepterrier',
    type: 'dog',
    id: 'Cross-327',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cairn Corgi',
    type: 'dog',
    id: 'Cross-328',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairnese',
    type: 'dog',
    id: 'Cross-329',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cairnoodle',
    type: 'dog',
    id: 'Cross-330',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairnwich Terrier',
    type: 'dog',
    id: 'Cross-331',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cairoston',
    type: 'dog',
    id: 'Cross-332',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Cane Corxer',
    type: 'dog',
    id: 'Cross-333',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cardigan Corgi Pointer',
    type: 'dog',
    id: 'Cross-334',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cardigan Corman Shepherd',
    type: 'dog',
    id: 'Cross-335',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Cardigan Corswiss',
    type: 'dog',
    id: 'Cross-336',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cardigan Pembroke Corgi',
    type: 'dog',
    id: 'Cross-337',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Care-Tzu',
    type: 'dog',
    id: 'Cross-338',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Carengi',
    type: 'dog',
    id: 'Cross-339',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Carkie',
    type: 'dog',
    id: 'Cross-340',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Carnauzer',
    type: 'dog',
    id: 'Cross-341',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Catahoula Bulldog',
    type: 'dog',
    id: 'Cross-342',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Catahoula Dane',
    type: 'dog',
    id: 'Cross-343',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Catahoula English Bulldog',
    type: 'dog',
    id: 'Cross-344',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Catahoula Heeler',
    type: 'dog',
    id: 'Cross-345',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Catahoula Rottie',
    type: 'dog',
    id: 'Cross-346',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Catahoula Whippet',
    type: 'dog',
    id: 'Cross-347',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cattle Collie Dog',
    type: 'dog',
    id: 'Cross-348',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cattle Shepherd',
    type: 'dog',
    id: 'Cross-349',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Caucasian Husky',
    type: 'dog',
    id: 'Cross-350',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Caucasian Staffy Bull',
    type: 'dog',
    id: 'Cross-351',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cav-A-Malt',
    type: 'dog',
    id: 'Cross-352',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cav-A-Mo',
    type: 'dog',
    id: 'Cross-353',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cava-Chin',
    type: 'dog',
    id: 'Cross-354',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cava-Corgi',
    type: 'dog',
    id: 'Cross-355',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cav-A-Jack',
    type: 'dog',
    id: 'Cross-356',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cava Inu',
    type: 'dog',
    id: 'Cross-357',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cava-lon',
    type: 'dog',
    id: 'Cross-358',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cava-Tzu',
    type: 'dog',
    id: 'Cross-359',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cavachon',
    type: 'dog',
    id: 'Cross-360',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cavador',
    type: 'dog',
    id: 'Cross-361',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cavanese',
    type: 'dog',
    id: 'Cross-362',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cavapom',
    type: 'dog',
    id: 'Cross-363',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '118',
    breedName: 'Cavapoo',
    type: 'dog',
    id: 'Cross-364',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cavaton',
    type: 'dog',
    id: 'Cross-365',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cava-Shell',
    type: 'dog',
    id: 'Cross-366',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cavestie',
    type: 'dog',
    id: 'Cross-367',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cavottish',
    type: 'dog',
    id: 'Cross-368',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chabrador',
    type: 'dog',
    id: 'Cross-369',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chatham Hill Retriever',
    type: 'dog',
    id: 'Cross-370',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chatterdale',
    type: 'dog',
    id: 'Cross-371',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cheagle',
    type: 'dog',
    id: 'Cross-372',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cheeks',
    type: 'dog',
    id: 'Cross-373',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cheenese',
    type: 'dog',
    id: 'Cross-374',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Cherokee Monarch',
    type: 'dog',
    id: 'Cross-375',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chesa-Poo',
    type: 'dog',
    id: 'Cross-376',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chesador',
    type: 'dog',
    id: 'Cross-377',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Crested Boxer',
    type: 'dog',
    id: 'Cross-378',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chestie',
    type: 'dog',
    id: 'Cross-379',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chi Apso',
    type: 'dog',
    id: 'Cross-380',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chi-Chi',
    type: 'dog',
    id: 'Cross-381',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chi-Chon',
    type: 'dog',
    id: 'Cross-382',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chidale',
    type: 'dog',
    id: 'Cross-383',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chi-Poo',
    type: 'dog',
    id: 'Cross-384',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Chi-Spaniel',
    type: 'dog',
    id: 'Cross-385',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Chi Staffy',
    type: 'dog',
    id: 'Cross-386',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Chi Staffy Bull',
    type: 'dog',
    id: 'Cross-387',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Chigi',
    type: 'dog',
    id: 'Cross-388',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chilier',
    type: 'dog',
    id: 'Cross-389',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chimation',
    type: 'dog',
    id: 'Cross-390',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Chimo',
    type: 'dog',
    id: 'Cross-391',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chin Crested',
    type: 'dog',
    id: 'Cross-392',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chin-Fenpinscher',
    type: 'dog',
    id: 'Cross-393',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Chin-Ocker',
    type: 'dog',
    id: 'Cross-394',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chin-Pin',
    type: 'dog',
    id: 'Cross-395',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chin-wa',
    type: 'dog',
    id: 'Cross-396',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'China Jack',
    type: 'dog',
    id: 'Cross-397',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chinaranian',
    type: 'dog',
    id: 'Cross-398',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chineranian',
    type: 'dog',
    id: 'Cross-399',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chinese Crestepoo',
    type: 'dog',
    id: 'Cross-400',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chinese Crestese',
    type: 'dog',
    id: 'Cross-401',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chinese Frise',
    type: 'dog',
    id: 'Cross-402',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chion',
    type: 'dog',
    id: 'Cross-403',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chipin',
    type: 'dog',
    id: 'Cross-404',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Chipit',
    type: 'dog',
    id: 'Cross-405',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chisenji',
    type: 'dog',
    id: 'Cross-406',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chiweenie',
    type: 'dog',
    id: 'Cross-407',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chiwoxy',
    type: 'dog',
    id: 'Cross-408',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chizer',
    type: 'dog',
    id: 'Cross-409',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chonzer',
    type: 'dog',
    id: 'Cross-410',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chorkie',
    type: 'dog',
    id: 'Cross-411',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chow Hound Basset',
    type: 'dog',
    id: 'Cross-412',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chow Pei',
    type: 'dog',
    id: 'Cross-413',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Chowpit',
    type: 'dog',
    id: 'Cross-414',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chow Shepherd',
    type: 'dog',
    id: 'Cross-415',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chug',
    type: 'dog',
    id: 'Cross-416',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chusky',
    type: 'dog',
    id: 'Cross-417',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Chussel',
    type: 'dog',
    id: 'Cross-418',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Chuvasz',
    type: 'dog',
    id: 'Cross-419',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Carillon',
    type: 'dog',
    id: 'Cross-420',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Clumber Lab',
    type: 'dog',
    id: 'Cross-421',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Clumber Pei',
    type: 'dog',
    id: 'Cross-422',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Clumberton',
    type: 'dog',
    id: 'Cross-423',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cluminger Spaniel',
    type: 'dog',
    id: 'Cross-424',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Clumberstiff',
    type: 'dog',
    id: 'Cross-425',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cock-A-Chon',
    type: 'dog',
    id: 'Cross-426',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cock-A-Mo',
    type: 'dog',
    id: 'Cross-427',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cock-A-Tzu',
    type: 'dog',
    id: 'Cross-428',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cockalier',
    type: 'dog',
    id: 'Cross-429',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cockapin',
    type: 'dog',
    id: 'Cross-430',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '130',
    breedName: 'Cockapoo',
    type: 'dog',
    id: 'Cross-431',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cocker Chow',
    type: 'dog',
    id: 'Cross-432',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker Griffon',
    type: 'dog',
    id: 'Cross-433',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker Jack',
    type: 'dog',
    id: 'Cross-434',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cocker-Pei',
    type: 'dog',
    id: 'Cross-435',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker Pug',
    type: 'dog',
    id: 'Cross-436',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker Sheltie',
    type: 'dog',
    id: 'Cross-437',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker-Ton',
    type: 'dog',
    id: 'Cross-438',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cocker Weim',
    type: 'dog',
    id: 'Cross-439',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker Westie',
    type: 'dog',
    id: 'Cross-440',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cocker Wheaten',
    type: 'dog',
    id: 'Cross-441',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cockeranian',
    type: 'dog',
    id: 'Cross-442',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cockerbull',
    type: 'dog',
    id: 'Cross-443',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cockinese',
    type: 'dog',
    id: 'Cross-444',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cojack',
    type: 'dog',
    id: 'Cross-445',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Collie Pyrenees',
    type: 'dog',
    id: 'Cross-446',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Colonial Cocker Spaniel',
    type: 'dog',
    id: 'Cross-447',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Confetti Australian Shepherd',
    type: 'dog',
    id: 'Cross-448',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Copica',
    type: 'dog',
    id: 'Cross-449',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Corgi Basset',
    type: 'dog',
    id: 'Cross-450',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corgi Bichon',
    type: 'dog',
    id: 'Cross-451',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corgi Cattle Dog',
    type: 'dog',
    id: 'Cross-452',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Corgi-Flat',
    type: 'dog',
    id: 'Cross-453',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Corgi Pit',
    type: 'dog',
    id: 'Cross-454',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Corgi Pointer',
    type: 'dog',
    id: 'Cross-455',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corgi Pug',
    type: 'dog',
    id: 'Cross-456',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corgi Schip',
    type: 'dog',
    id: 'Cross-457',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Corgidor',
    type: 'dog',
    id: 'Cross-458',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Corgipoo',
    type: 'dog',
    id: 'Cross-459',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corgiranian',
    type: 'dog',
    id: 'Cross-460',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corillon',
    type: 'dog',
    id: 'Cross-461',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corkie',
    type: 'dog',
    id: 'Cross-462',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Corman Shepherd',
    type: 'dog',
    id: 'Cross-463',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corpin',
    type: 'dog',
    id: 'Cross-464',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Corsengi',
    type: 'dog',
    id: 'Cross-465',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Corswiss',
    type: 'dog',
    id: 'Cross-466',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cortese',
    type: 'dog',
    id: 'Cross-467',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Cosheltie',
    type: 'dog',
    id: 'Cross-468',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Coton-Beagle',
    type: 'dog',
    id: 'Cross-469',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Coton Bolonka',
    type: 'dog',
    id: 'Cross-470',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Coton Chin',
    type: 'dog',
    id: 'Cross-471',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Coton Eskimo',
    type: 'dog',
    id: 'Cross-472',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Coton Mi-ki',
    type: 'dog',
    id: 'Cross-473',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Coton Schnauzer',
    type: 'dog',
    id: 'Cross-474',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Coton Tzu',
    type: 'dog',
    id: 'Cross-475',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Cotonese',
    type: 'dog',
    id: 'Cross-476',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Cotralian',
    type: 'dog',
    id: 'Cross-477',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Coydog',
    type: 'dog',
    id: 'Cross-478',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Apso',
    type: 'dog',
    id: 'Cross-479',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Beagle',
    type: 'dog',
    id: 'Cross-480',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Cavalier',
    type: 'dog',
    id: 'Cross-481',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Chin',
    type: 'dog',
    id: 'Cross-482',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Crested Cocker',
    type: 'dog',
    id: 'Cross-483',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Havanese',
    type: 'dog',
    id: 'Cross-484',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Malt',
    type: 'dog',
    id: 'Cross-485',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Peke',
    type: 'dog',
    id: 'Cross-486',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Schnauzer',
    type: 'dog',
    id: 'Cross-487',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Tzu',
    type: 'dog',
    id: 'Cross-488',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crested Westie',
    type: 'dog',
    id: 'Cross-489',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crestoxie',
    type: 'dog',
    id: 'Cross-490',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Croatian Sheepsky',
    type: 'dog',
    id: 'Cross-491',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Crustie',
    type: 'dog',
    id: 'Cross-492',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Cursset',
    type: 'dog',
    id: 'Cross-493',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Dach-Griffon',
    type: 'dog',
    id: 'Cross-494',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dachsador',
    type: 'dog',
    id: 'Cross-495',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Dachsi Apso',
    type: 'dog',
    id: 'Cross-496',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dachsweiler',
    type: 'dog',
    id: 'Cross-497',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Daisy Dog',
    type: 'dog',
    id: 'Cross-498',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dalmadoodle',
    type: 'dog',
    id: 'Cross-499',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dalmador',
    type: 'dog',
    id: 'Cross-500',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Dalmatian Feist',
    type: 'dog',
    id: 'Cross-501',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dalmatian Heeler',
    type: 'dog',
    id: 'Cross-502',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dalmatian Husky',
    type: 'dog',
    id: 'Cross-503',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dalmatian Springer',
    type: 'dog',
    id: 'Cross-504',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Dameranian',
    type: 'dog',
    id: 'Cross-505',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dane Shepherd',
    type: 'dog',
    id: 'Cross-506',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Daniff',
    type: 'dog',
    id: 'Cross-507',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Dashalier',
    type: 'dog',
    id: 'Cross-508',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Daug',
    type: 'dog',
    id: 'Cross-509',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Decker Brat',
    type: 'dog',
    id: 'Cross-510',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Deerhound Shepherd',
    type: 'dog',
    id: 'Cross-511',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Dingo Kelpie',
    type: 'dog',
    id: 'Cross-512',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Dingo Podenco',
    type: 'dog',
    id: 'Cross-513',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberman Greyhound',
    type: 'dog',
    id: 'Cross-514',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberdane',
    type: 'dog',
    id: 'Cross-515',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberdor',
    type: 'dog',
    id: 'Cross-516',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberghan',
    type: 'dog',
    id: 'Cross-517',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberman Bulldog',
    type: 'dog',
    id: 'Cross-518',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberman Collie',
    type: 'dog',
    id: 'Cross-519',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Doberman Pit',
    type: 'dog',
    id: 'Cross-520',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doberman Shepherd',
    type: 'dog',
    id: 'Cross-521',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobie-Basset',
    type: 'dog',
    id: 'Cross-522',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobie Foxhound',
    type: 'dog',
    id: 'Cross-523',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobie Heeler',
    type: 'dog',
    id: 'Cross-524',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobie Schnauzer',
    type: 'dog',
    id: 'Cross-525',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobieton',
    type: 'dog',
    id: 'Cross-526',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobocker',
    type: 'dog',
    id: 'Cross-527',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dobsky',
    type: 'dog',
    id: 'Cross-528',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Docker',
    type: 'dog',
    id: 'Cross-529',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Dogo Pit',
    type: 'dog',
    id: 'Cross-530',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dogue Brasileiro',
    type: 'dog',
    id: 'Cross-531',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dogue de Boxer',
    type: 'dog',
    id: 'Cross-532',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doguedoodle',
    type: 'dog',
    id: 'Cross-533',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doodleman Pinscher',
    type: 'dog',
    id: 'Cross-534',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Dorgi',
    type: 'dog',
    id: 'Cross-535',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Dorkie',
    type: 'dog',
    id: 'Cross-536',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doubull-Mastiff',
    type: 'dog',
    id: 'Cross-537',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Double Doodle',
    type: 'dog',
    id: 'Cross-538',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Doxie Cairn',
    type: 'dog',
    id: 'Cross-539',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Doxie-Chin',
    type: 'dog',
    id: 'Cross-540',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Doxie-Chon',
    type: 'dog',
    id: 'Cross-541',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Doxie Heeler',
    type: 'dog',
    id: 'Cross-542',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Doxie Scot',
    type: 'dog',
    id: 'Cross-543',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Doxie-Pin',
    type: 'dog',
    id: 'Cross-544',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Doxie-Pit',
    type: 'dog',
    id: 'Cross-545',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Doxiemo',
    type: 'dog',
    id: 'Cross-546',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Doxiepoo',
    type: 'dog',
    id: 'Cross-547',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Doxle',
    type: 'dog',
    id: 'Cross-548',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Dualanese',
    type: 'dog',
    id: 'Cross-549',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Dusky',
    type: 'dog',
    id: 'Cross-550',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Dutchie Chow Shepherd',
    type: 'dog',
    id: 'Cross-551',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Elk-a-Bee',
    type: 'dog',
    id: 'Cross-552',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Elkhound Shepherd',
    type: 'dog',
    id: 'Cross-553',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Elk-Kee',
    type: 'dog',
    id: 'Cross-554',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Eng-A-Poo',
    type: 'dog',
    id: 'Cross-555',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Enga-Apso',
    type: 'dog',
    id: 'Cross-556',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Engachon',
    type: 'dog',
    id: 'Cross-557',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'EngAm Bulldog x Olde Bulldog',
    type: 'dog',
    id: 'Cross-558',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Enganese',
    type: 'dog',
    id: 'Cross-559',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Engatzu Spaniel',
    type: 'dog',
    id: 'Cross-560',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Englian Mastiff',
    type: 'dog',
    id: 'Cross-561',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Boodle',
    type: 'dog',
    id: 'Cross-562',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Borsetter Collie',
    type: 'dog',
    id: 'Cross-563',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Boston-Bulldog',
    type: 'dog',
    id: 'Cross-564',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Boxetter',
    type: 'dog',
    id: 'Cross-565',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bull Dane',
    type: 'dog',
    id: 'Cross-566',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bull Springer',
    type: 'dog',
    id: 'Cross-567',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'English Bull Terrier Pit',
    type: 'dog',
    id: 'Cross-568',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bullamute',
    type: 'dog',
    id: 'Cross-569',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'English Bull Staffy',
    type: 'dog',
    id: 'Cross-570',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bull-Walker',
    type: 'dog',
    id: 'Cross-571',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bullweiler',
    type: 'dog',
    id: 'Cross-572',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bulldog Terrier',
    type: 'dog',
    id: 'Cross-573',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bulltyme',
    type: 'dog',
    id: 'Cross-574',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Bully Staffy Bull Terrier',
    type: 'dog',
    id: 'Cross-575',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'English Catahoula Shepherd',
    type: 'dog',
    id: 'Cross-576',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Cocker Chow',
    type: 'dog',
    id: 'Cross-577',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'English Collie Shepherd',
    type: 'dog',
    id: 'Cross-578',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Coonoodle',
    type: 'dog',
    id: 'Cross-579',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Coon Rottie',
    type: 'dog',
    id: 'Cross-580',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Cotralian',
    type: 'dog',
    id: 'Cross-581',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'English King',
    type: 'dog',
    id: 'Cross-582',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Lhasa Bull',
    type: 'dog',
    id: 'Cross-583',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'English Mastahoula',
    type: 'dog',
    id: 'Cross-584',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Mastweiler',
    type: 'dog',
    id: 'Cross-585',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'English Mini Foxker',
    type: 'dog',
    id: 'Cross-586',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Neo Bull',
    type: 'dog',
    id: 'Cross-587',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'English Presa Bulldog',
    type: 'dog',
    id: 'Cross-588',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Spanador',
    type: 'dog',
    id: 'Cross-589',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Spantriever',
    type: 'dog',
    id: 'Cross-590',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'English Speagle',
    type: 'dog',
    id: 'Cross-591',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Springerman',
    type: 'dog',
    id: 'Cross-592',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'English Sprointer',
    type: 'dog',
    id: 'Cross-593',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'English Toy Chin Spaniel',
    type: 'dog',
    id: 'Cross-594',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'English Toy Cocker Spaniel',
    type: 'dog',
    id: 'Cross-595',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'English Toy Griffon',
    type: 'dog',
    id: 'Cross-596',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'English Toy Papillon',
    type: 'dog',
    id: 'Cross-597',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'English Toy Spanese',
    type: 'dog',
    id: 'Cross-598',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Entlebucher Pit',
    type: 'dog',
    id: 'Cross-599',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Eskapoo',
    type: 'dog',
    id: 'Cross-600',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskenji',
    type: 'dog',
    id: 'Cross-601',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Eskidor',
    type: 'dog',
    id: 'Cross-602',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskifon',
    type: 'dog',
    id: 'Cross-603',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskijack',
    type: 'dog',
    id: 'Cross-604',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskimo Chi',
    type: 'dog',
    id: 'Cross-605',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskimo Chin',
    type: 'dog',
    id: 'Cross-606',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Eskimo Pit',
    type: 'dog',
    id: 'Cross-607',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskimo Schnauzer',
    type: 'dog',
    id: 'Cross-608',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Eskimo Shepherd',
    type: 'dog',
    id: 'Cross-609',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskimo Yorkie',
    type: 'dog',
    id: 'Cross-610',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Eskland',
    type: 'dog',
    id: 'Cross-611',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Euro Mountain Sheparnese',
    type: 'dog',
    id: 'Cross-612',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Ewokian',
    type: 'dog',
    id: 'Cross-613',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Faux Frenchbo Bulldog',
    type: 'dog',
    id: 'Cross-614',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Feist Chi',
    type: 'dog',
    id: 'Cross-615',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Feist Tzu',
    type: 'dog',
    id: 'Cross-616',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Fila Tosa',
    type: 'dog',
    id: 'Cross-617',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Finnish Chow Spitz',
    type: 'dog',
    id: 'Cross-618',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Flandoodle',
    type: 'dog',
    id: 'Cross-619',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Fo-Tzu',
    type: 'dog',
    id: 'Cross-620',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Foodle',
    type: 'dog',
    id: 'Cross-621',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Fourche Terrier',
    type: 'dog',
    id: 'Cross-622',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Foxhoodle',
    type: 'dog',
    id: 'Cross-623',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Foxingese',
    type: 'dog',
    id: 'Cross-624',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Foxker',
    type: 'dog',
    id: 'Cross-625',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Foxton',
    type: 'dog',
    id: 'Cross-626',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Foxy Rat Terrier',
    type: 'dog',
    id: 'Cross-627',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Foxy Russell',
    type: 'dog',
    id: 'Cross-628',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Free-Lance Bulldog',
    type: 'dog',
    id: 'Cross-629',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'French Afghan Mastiff',
    type: 'dog',
    id: 'Cross-630',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Buillon',
    type: 'dog',
    id: 'Cross-631',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'French Bull Dane',
    type: 'dog',
    id: 'Cross-632',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Bull Jack',
    type: 'dog',
    id: 'Cross-633',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'French Bull Rat Terrier',
    type: 'dog',
    id: 'Cross-634',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'French Bull Terrier',
    type: 'dog',
    id: 'Cross-635',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Bull Tzu',
    type: 'dog',
    id: 'Cross-636',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Bull Weiner',
    type: 'dog',
    id: 'Cross-637',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Bullhuahua',
    type: 'dog',
    id: 'Cross-638',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Bullnese',
    type: 'dog',
    id: 'Cross-639',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'French Bulloxer',
    type: 'dog',
    id: 'Cross-640',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'French Bullweiler',
    type: 'dog',
    id: 'Cross-641',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'French Masti-Bull',
    type: 'dog',
    id: 'Cross-642',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'French Mastahoula',
    type: 'dog',
    id: 'Cross-643',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French Pin',
    type: 'dog',
    id: 'Cross-644',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'French West Highlander',
    type: 'dog',
    id: 'Cross-645',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Frenchie Bichon',
    type: 'dog',
    id: 'Cross-646',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Frenchie Labrador',
    type: 'dog',
    id: 'Cross-647',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Frenchie-Pei',
    type: 'dog',
    id: 'Cross-648',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Frenchie Pug',
    type: 'dog',
    id: 'Cross-649',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Frenchie Shepherd',
    type: 'dog',
    id: 'Cross-650',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Frenchie Staff',
    type: 'dog',
    id: 'Cross-651',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Frenchnese',
    type: 'dog',
    id: 'Cross-652',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Frengle',
    type: 'dog',
    id: 'Cross-653',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Froodle',
    type: 'dog',
    id: 'Cross-654',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Gerberian Shepsky',
    type: 'dog',
    id: 'Cross-655',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Anatolian Shepherd',
    type: 'dog',
    id: 'Cross-656',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Australian Shepherd',
    type: 'dog',
    id: 'Cross-657',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Groenendael',
    type: 'dog',
    id: 'Cross-658',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Longhaired Sprointer',
    type: 'dog',
    id: 'Cross-659',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Malinois',
    type: 'dog',
    id: 'Cross-660',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'German Sheltie Spitz',
    type: 'dog',
    id: 'Cross-661',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Sheprador',
    type: 'dog',
    id: 'Cross-662',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'German Shorthair Toller',
    type: 'dog',
    id: 'Cross-663',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Shorthaired Lab',
    type: 'dog',
    id: 'Cross-664',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Shorthaired Sprointer',
    type: 'dog',
    id: 'Cross-665',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Shorthaired Weimaraner',
    type: 'dog',
    id: 'Cross-666',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Spitz Shepherd',
    type: 'dog',
    id: 'Cross-667',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Spitzpoo',
    type: 'dog',
    id: 'Cross-668',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Wirehaired Lab',
    type: 'dog',
    id: 'Cross-669',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Wirehaired Newfie',
    type: 'dog',
    id: 'Cross-670',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Wirehaired Pointing Wolfhound',
    type: 'dog',
    id: 'Cross-671',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Wirehaired Sprointer',
    type: 'dog',
    id: 'Cross-672',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'German Yorkie Shepherd',
    type: 'dog',
    id: 'Cross-673',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Germanees',
    type: 'dog',
    id: 'Cross-674',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Bolonauzer',
    type: 'dog',
    id: 'Cross-675',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Border Schnollie',
    type: 'dog',
    id: 'Cross-676',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Irish Wolf Schnauzer',
    type: 'dog',
    id: 'Cross-677',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Kerry Blue Schnauzer',
    type: 'dog',
    id: 'Cross-678',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Komondauzer',
    type: 'dog',
    id: 'Cross-679',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Giant Ratzer',
    type: 'dog',
    id: 'Cross-680',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Schnauzer Chin',
    type: 'dog',
    id: 'Cross-681',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Schnoodle',
    type: 'dog',
    id: 'Cross-682',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Wauzer',
    type: 'dog',
    id: 'Cross-683',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Giant Wire Hair Snauzer',
    type: 'dog',
    id: 'Cross-684',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Glechon',
    type: 'dog',
    id: 'Cross-685',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goberian',
    type: 'dog',
    id: 'Cross-686',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Akita Retriever',
    type: 'dog',
    id: 'Cross-687',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Border Retriever',
    type: 'dog',
    id: 'Cross-688',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Boxer',
    type: 'dog',
    id: 'Cross-689',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Bulldog',
    type: 'dog',
    id: 'Cross-690',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Bullmastiff Retriever',
    type: 'dog',
    id: 'Cross-691',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Cavalier',
    type: 'dog',
    id: 'Cross-692',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Chesabay',
    type: 'dog',
    id: 'Cross-693',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Chi Retriever',
    type: 'dog',
    id: 'Cross-694',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Chow Retriever',
    type: 'dog',
    id: 'Cross-695',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Cocker Retriever',
    type: 'dog',
    id: 'Cross-696',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Dox',
    type: 'dog',
    id: 'Cross-697',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Golden Indian Dog',
    type: 'dog',
    id: 'Cross-698',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Irish',
    type: 'dog',
    id: 'Cross-699',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Jack Retriever',
    type: 'dog',
    id: 'Cross-700',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Labrador',
    type: 'dog',
    id: 'Cross-701',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Mastiff',
    type: 'dog',
    id: 'Cross-702',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Mountain Dog',
    type: 'dog',
    id: 'Cross-703',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Newfie',
    type: 'dog',
    id: 'Cross-704',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Pei',
    type: 'dog',
    id: 'Cross-705',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Golden Pyrenees',
    type: 'dog',
    id: 'Cross-706',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Rottie Retriever',
    type: 'dog',
    id: 'Cross-707',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Saint',
    type: 'dog',
    id: 'Cross-708',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Sammy',
    type: 'dog',
    id: 'Cross-709',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Sheltie',
    type: 'dog',
    id: 'Cross-710',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Shepherd',
    type: 'dog',
    id: 'Cross-711',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Tibetan Tertriever',
    type: 'dog',
    id: 'Cross-712',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Golden Toller Retriever',
    type: 'dog',
    id: 'Cross-713',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goldenapso Retriever',
    type: 'dog',
    id: 'Cross-714',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goldendale',
    type: 'dog',
    id: 'Cross-715',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goldenshire',
    type: 'dog',
    id: 'Cross-716',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goldendoodle',
    type: 'dog',
    id: 'Cross-717',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goldmaraner',
    type: 'dog',
    id: 'Cross-718',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Goldmation',
    type: 'dog',
    id: 'Cross-719',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Gollie',
    type: 'dog',
    id: 'Cross-720',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Gordon Chesabay',
    type: 'dog',
    id: 'Cross-721',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Gordon Sheltie',
    type: 'dog',
    id: 'Cross-722',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Gordondoodle',
    type: 'dog',
    id: 'Cross-723',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Bernese',
    type: 'dog',
    id: 'Cross-724',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Cambrian Shepherd',
    type: 'dog',
    id: 'Cross-725',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Danebull',
    type: 'dog',
    id: 'Cross-726',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Great Danesky',
    type: 'dog',
    id: 'Cross-727',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Great Danoodle',
    type: 'dog',
    id: 'Cross-728',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Great Dasenji',
    type: 'dog',
    id: 'Cross-729',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Great Golden Dane',
    type: 'dog',
    id: 'Cross-730',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Keeshees',
    type: 'dog',
    id: 'Cross-731',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Pyredane',
    type: 'dog',
    id: 'Cross-732',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Great Weimar',
    type: 'dog',
    id: 'Cross-733',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Wirehaired Gryfenees',
    type: 'dog',
    id: 'Cross-734',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Great Wolfhound',
    type: 'dog',
    id: 'Cross-735',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Greater Swiss Mountain Dane',
    type: 'dog',
    id: 'Cross-736',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Greater Swiss Rottweiler',
    type: 'dog',
    id: 'Cross-737',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Greater Welsh Corswiss',
    type: 'dog',
    id: 'Cross-738',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Greyador',
    type: 'dog',
    id: 'Cross-739',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Greybull Pit',
    type: 'dog',
    id: 'Cross-740',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Greyhound Shepherd',
    type: 'dog',
    id: 'Cross-741',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Griffairn Terrier',
    type: 'dog',
    id: 'Cross-742',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Griffichon',
    type: 'dog',
    id: 'Cross-743',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Griffon-Pei',
    type: 'dog',
    id: 'Cross-744',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Griffonese',
    type: 'dog',
    id: 'Cross-745',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Griffonland',
    type: 'dog',
    id: 'Cross-746',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Griffonshire',
    type: 'dog',
    id: 'Cross-747',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Groenendael Chow',
    type: 'dog',
    id: 'Cross-748',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Hava-Apso',
    type: 'dog',
    id: 'Cross-749',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Hava-Boston',
    type: 'dog',
    id: 'Cross-750',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Hava-Jack',
    type: 'dog',
    id: 'Cross-751',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Hava Klee',
    type: 'dog',
    id: 'Cross-752',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Hava-Welsh',
    type: 'dog',
    id: 'Cross-753',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Hava-Wheat',
    type: 'dog',
    id: 'Cross-754',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havachin',
    type: 'dog',
    id: 'Cross-755',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havachon',
    type: 'dog',
    id: 'Cross-756',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Havaco',
    type: 'dog',
    id: 'Cross-757',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havallon',
    type: 'dog',
    id: 'Cross-758',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havamalt',
    type: 'dog',
    id: 'Cross-759',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havanestie',
    type: 'dog',
    id: 'Cross-760',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havapeke',
    type: 'dog',
    id: 'Cross-761',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havashire',
    type: 'dog',
    id: 'Cross-762',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havashu',
    type: 'dog',
    id: 'Cross-763',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Havaton',
    type: 'dog',
    id: 'Cross-764',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Heeler Pei',
    type: 'dog',
    id: 'Cross-765',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Highland Maltie',
    type: 'dog',
    id: 'Cross-766',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Hovie Gold Retriever',
    type: 'dog',
    id: 'Cross-767',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Hug',
    type: 'dog',
    id: 'Cross-768',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Hush Basset',
    type: 'dog',
    id: 'Cross-769',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Husker',
    type: 'dog',
    id: 'Cross-770',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Huskimo',
    type: 'dog',
    id: 'Cross-771',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Huskita',
    type: 'dog',
    id: 'Cross-772',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Husky Jack',
    type: 'dog',
    id: 'Cross-773',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Husky Wheaten',
    type: 'dog',
    id: 'Cross-774',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Imo-Inu',
    type: 'dog',
    id: 'Cross-775',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Afghan Setter',
    type: 'dog',
    id: 'Cross-776',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Bostetter',
    type: 'dog',
    id: 'Cross-777',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Irish Boston Terrier',
    type: 'dog',
    id: 'Cross-778',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Dane',
    type: 'dog',
    id: 'Cross-779',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Dobe Setter',
    type: 'dog',
    id: 'Cross-780',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Doodle',
    type: 'dog',
    id: 'Cross-781',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Irish Jack Terrier',
    type: 'dog',
    id: 'Cross-782',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Irish Lakeland Terrier',
    type: 'dog',
    id: 'Cross-783',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Mastiff',
    type: 'dog',
    id: 'Cross-784',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Russian Spanterrier',
    type: 'dog',
    id: 'Cross-785',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Troodle',
    type: 'dog',
    id: 'Cross-786',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Wolf Greyhound',
    type: 'dog',
    id: 'Cross-787',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Wolfoodle',
    type: 'dog',
    id: 'Cross-788',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Wolf Schnauzer',
    type: 'dog',
    id: 'Cross-789',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Wolfsky',
    type: 'dog',
    id: 'Cross-790',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Greycrested',
    type: 'dog',
    id: 'Cross-791',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Greyenji',
    type: 'dog',
    id: 'Cross-792',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian-Bichon',
    type: 'dog',
    id: 'Cross-793',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Italian Border Greyollie',
    type: 'dog',
    id: 'Cross-794',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Italian Bulldogge',
    type: 'dog',
    id: 'Cross-795',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Cairn',
    type: 'dog',
    id: 'Cross-796',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Cavalier Greyhound',
    type: 'dog',
    id: 'Cross-797',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Italian Daniff',
    type: 'dog',
    id: 'Cross-798',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Doxie',
    type: 'dog',
    id: 'Cross-799',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Italian Eskimo',
    type: 'dog',
    id: 'Cross-800',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Greagle',
    type: 'dog',
    id: 'Cross-801',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Grey Min Pin',
    type: 'dog',
    id: 'Cross-802',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Greyhuahua',
    type: 'dog',
    id: 'Cross-803',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Italian Mastweiler',
    type: 'dog',
    id: 'Cross-804',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Papihound',
    type: 'dog',
    id: 'Cross-805',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Irish Saint Terrier',
    type: 'dog',
    id: 'Cross-806',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Tzu',
    type: 'dog',
    id: 'Cross-807',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Italian Whippet Greyhound',
    type: 'dog',
    id: 'Cross-808',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Ja-Chon',
    type: 'dog',
    id: 'Cross-809',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jacairn',
    type: 'dog',
    id: 'Cross-810',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jack-A-Bee',
    type: 'dog',
    id: 'Cross-811',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Jack-A-Poo',
    type: 'dog',
    id: 'Cross-812',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jack-A-Ranian',
    type: 'dog',
    id: 'Cross-813',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jack Chi',
    type: 'dog',
    id: 'Cross-814',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jack Highland Terrier',
    type: 'dog',
    id: 'Cross-815',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Jack Pit',
    type: 'dog',
    id: 'Cross-816',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Jack-Rat Terrier',
    type: 'dog',
    id: 'Cross-817',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Jack Russell Greyhound',
    type: 'dog',
    id: 'Cross-818',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jack Tzu',
    type: 'dog',
    id: 'Cross-819',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jackie-Bichon',
    type: 'dog',
    id: 'Cross-820',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jackshund',
    type: 'dog',
    id: 'Cross-821',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Jackweiler',
    type: 'dog',
    id: 'Cross-822',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jafox',
    type: 'dog',
    id: 'Cross-823',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jaland',
    type: 'dog',
    id: 'Cross-824',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Japanese Chow Spitz',
    type: 'dog',
    id: 'Cross-825',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Japanese Spitz Chi',
    type: 'dog',
    id: 'Cross-826',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Japanese Thai Ridgespitz',
    type: 'dog',
    id: 'Cross-827',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Japeke',
    type: 'dog',
    id: 'Cross-828',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Japillon',
    type: 'dog',
    id: 'Cross-829',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Japug',
    type: 'dog',
    id: 'Cross-830',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jarkie',
    type: 'dog',
    id: 'Cross-831',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jatese',
    type: 'dog',
    id: 'Cross-832',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jatzu',
    type: 'dog',
    id: 'Cross-833',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Jug',
    type: 'dog',
    id: 'Cross-834',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Kashon',
    type: 'dog',
    id: 'Cross-835',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kelpie Corgi',
    type: 'dog',
    id: 'Cross-836',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kelpie Heeler',
    type: 'dog',
    id: 'Cross-837',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Kelpie Lab',
    type: 'dog',
    id: 'Cross-838',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Kelpie Shepherd',
    type: 'dog',
    id: 'Cross-839',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Kelpie Staff',
    type: 'dog',
    id: 'Cross-840',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kerry Blue Schnauzer',
    type: 'dog',
    id: 'Cross-841',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kerrblushcnauz',
    type: 'dog',
    id: 'Cross-842',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kerry Wheaten',
    type: 'dog',
    id: 'Cross-843',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kimola',
    type: 'dog',
    id: 'Cross-844',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'King Cavrin',
    type: 'dog',
    id: 'Cross-845',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'King Charles Yorkie',
    type: 'dog',
    id: 'Cross-846',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'King Pin',
    type: 'dog',
    id: 'Cross-847',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'King Rat',
    type: 'dog',
    id: 'Cross-848',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'King Schnauzer',
    type: 'dog',
    id: 'Cross-849',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'King Wheaten',
    type: 'dog',
    id: 'Cross-850',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Kobetan',
    type: 'dog',
    id: 'Cross-851',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: `Lab'Aire`,
    type: 'dog',
    id: 'Cross-852',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Lab Apso',
    type: 'dog',
    id: 'Cross-853',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Lab Pei',
    type: 'dog',
    id: 'Cross-854',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Lab-Pointer',
    type: 'dog',
    id: 'Cross-855',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Labahoula',
    type: 'dog',
    id: 'Cross-856',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labany',
    type: 'dog',
    id: 'Cross-857',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labbe',
    type: 'dog',
    id: 'Cross-858',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labernard',
    type: 'dog',
    id: 'Cross-859',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labernese',
    type: 'dog',
    id: 'Cross-860',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labloodhound',
    type: 'dog',
    id: 'Cross-861',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labmaraner',
    type: 'dog',
    id: 'Cross-862',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labollie',
    type: 'dog',
    id: 'Cross-863',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Labrabull',
    type: 'dog',
    id: 'Cross-864',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labradane',
    type: 'dog',
    id: 'Cross-865',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labradinger',
    type: 'dog',
    id: 'Cross-866',
    isCrossBreed: true,
  },
  // commented breed, because we have the same breedName: 'Labradoodle' in the main breed list
  // our CM partner, decided we can use Labradoodle as a "pure" breed with its own id
  // {
  //   aliasToBreedId: '6',
  //   breedName: 'Labradoodle',
  //   type: 'dog',
  //   id: 'Cross-867',
  //
  //   isCrossBreed: true,
  // },
  {
    aliasToBreedId: '6',
    breedName: 'Labradoodle Miniature',
    type: 'dog',
    id: 'Cross-868',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Labrador Corso',
    type: 'dog',
    id: 'Cross-869',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labraheeler',
    type: 'dog',
    id: 'Cross-870',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labrahuahua',
    type: 'dog',
    id: 'Cross-871',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labrakita',
    type: 'dog',
    id: 'Cross-872',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labralas',
    type: 'dog',
    id: 'Cross-873',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labrasenji',
    type: 'dog',
    id: 'Cross-874',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Labrastaff',
    type: 'dog',
    id: 'Cross-875',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Labrottie',
    type: 'dog',
    id: 'Cross-876',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'La-Chon',
    type: 'dog',
    id: 'Cross-877',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lacasapoo',
    type: 'dog',
    id: 'Cross-878',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'La Pom',
    type: 'dog',
    id: 'Cross-879',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'LeoBerner',
    type: 'dog',
    id: 'Cross-880',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Lha-Basset',
    type: 'dog',
    id: 'Cross-881',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Lha-Cocker',
    type: 'dog',
    id: 'Cross-882',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Lhasa-Corgi',
    type: 'dog',
    id: 'Cross-883',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhasa-Coton',
    type: 'dog',
    id: 'Cross-884',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhasa Jack',
    type: 'dog',
    id: 'Cross-885',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhasa Pin',
    type: 'dog',
    id: 'Cross-886',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Lhasa Vendeen',
    type: 'dog',
    id: 'Cross-887',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhaffon',
    type: 'dog',
    id: 'Cross-888',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhasalier',
    type: 'dog',
    id: 'Cross-889',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhasanese',
    type: 'dog',
    id: 'Cross-890',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Lhasapoo',
    type: 'dog',
    id: 'Cross-891',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Lhatese',
    type: 'dog',
    id: 'Cross-892',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Malamute Pei',
    type: 'dog',
    id: 'Cross-893',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mal-Shi',
    type: 'dog',
    id: 'Cross-894',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Malanees',
    type: 'dog',
    id: 'Cross-895',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Malchi',
    type: 'dog',
    id: 'Cross-896',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Mali-dutchie',
    type: 'dog',
    id: 'Cross-897',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Malinois Akita',
    type: 'dog',
    id: 'Cross-898',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Malinois Greyhound',
    type: 'dog',
    id: 'Cross-899',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Malinois Mastiff',
    type: 'dog',
    id: 'Cross-900',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Malinois X',
    type: 'dog',
    id: 'Cross-901',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mally Foxhound',
    type: 'dog',
    id: 'Cross-902',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Malteagle',
    type: 'dog',
    id: 'Cross-903',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Malti-Pin',
    type: 'dog',
    id: 'Cross-904',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '221',
    breedName: 'Malti-Poo',
    type: 'dog',
    id: 'Cross-905',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Malti-Pug',
    type: 'dog',
    id: 'Cross-906',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Malti-Py',
    type: 'dog',
    id: 'Cross-907',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Maltichon',
    type: 'dog',
    id: 'Cross-908',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Maltipom',
    type: 'dog',
    id: 'Cross-909',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Malton',
    type: 'dog',
    id: 'Cross-910',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Maremma Kelpie',
    type: 'dog',
    id: 'Cross-911',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Maremma Shepherd',
    type: 'dog',
    id: 'Cross-912',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Maspyr',
    type: 'dog',
    id: 'Cross-913',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mastador',
    type: 'dog',
    id: 'Cross-914',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mastapeake',
    type: 'dog',
    id: 'Cross-915',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Masti-Bull',
    type: 'dog',
    id: 'Cross-916',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mastidoodle',
    type: 'dog',
    id: 'Cross-917',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mastiff Shepherd',
    type: 'dog',
    id: 'Cross-918',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mauxie',
    type: 'dog',
    id: 'Cross-919',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mauzer',
    type: 'dog',
    id: 'Cross-920',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Meagle',
    type: 'dog',
    id: 'Cross-921',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Mi-kitese',
    type: 'dog',
    id: 'Cross-922',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Mi-orkie',
    type: 'dog',
    id: 'Cross-923',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Min Pin Frise',
    type: 'dog',
    id: 'Cross-924',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Min Pin Shepherd',
    type: 'dog',
    id: 'Cross-925',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mini Australian Shepterrier',
    type: 'dog',
    id: 'Cross-926',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Bolonauzer',
    type: 'dog',
    id: 'Cross-927',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Cairn Pin',
    type: 'dog',
    id: 'Cross-928',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Chisoxy',
    type: 'dog',
    id: 'Cross-929',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Mini English Cocker',
    type: 'dog',
    id: 'Cross-930',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Fo-Chon',
    type: 'dog',
    id: 'Cross-931',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Fo-Tzu',
    type: 'dog',
    id: 'Cross-932',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mini Foodle',
    type: 'dog',
    id: 'Cross-933',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Fox Beagle',
    type: 'dog',
    id: 'Cross-934',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Fox Pinscher',
    type: 'dog',
    id: 'Cross-935',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Foxie Doxie',
    type: 'dog',
    id: 'Cross-936',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Foxillon',
    type: 'dog',
    id: 'Cross-937',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Foxingese',
    type: 'dog',
    id: 'Cross-938',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Mini Foxker',
    type: 'dog',
    id: 'Cross-939',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Foxton',
    type: 'dog',
    id: 'Cross-940',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Foxy Rat Terrier',
    type: 'dog',
    id: 'Cross-941',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Foxy Russell',
    type: 'dog',
    id: 'Cross-942',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Jafox',
    type: 'dog',
    id: 'Cross-943',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Mini Kerry Blue Schnauzer',
    type: 'dog',
    id: 'Cross-944',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini King Schnauzer',
    type: 'dog',
    id: 'Cross-945',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Poxer',
    type: 'dog',
    id: 'Cross-946',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Mini Ratzer',
    type: 'dog',
    id: 'Cross-947',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Schnauzer Chin',
    type: 'dog',
    id: 'Cross-948',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Schnauzer Jack',
    type: 'dog',
    id: 'Cross-949',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Scottish Fox Terrier',
    type: 'dog',
    id: 'Cross-950',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mini St. Bernard',
    type: 'dog',
    id: 'Cross-951',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mini Texas Heeler',
    type: 'dog',
    id: 'Cross-952',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Torkie',
    type: 'dog',
    id: 'Cross-953',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Toy Foxter',
    type: 'dog',
    id: 'Cross-954',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Mini Wire Hair Snauzer',
    type: 'dog',
    id: 'Cross-955',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mini Yorkshire Aussie',
    type: 'dog',
    id: 'Cross-956',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Ausseippet',
    type: 'dog',
    id: 'Cross-957',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Aussiedoodle',
    type: 'dog',
    id: 'Cross-958',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Miniature Border Schnollie',
    type: 'dog',
    id: 'Cross-959',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Boxer',
    type: 'dog',
    id: 'Cross-960',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Bulldog',
    type: 'dog',
    id: 'Cross-961',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature English Bulldach',
    type: 'dog',
    id: 'Cross-962',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Miniature French Bull Terrier',
    type: 'dog',
    id: 'Cross-963',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Miniature French Schnauzer',
    type: 'dog',
    id: 'Cross-964',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Golden Retriever',
    type: 'dog',
    id: 'Cross-965',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Goldendoodle',
    type: 'dog',
    id: 'Cross-966',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Gordondoodle',
    type: 'dog',
    id: 'Cross-967',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Irish Wolf Schnauzer',
    type: 'dog',
    id: 'Cross-968',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Labradoodle',
    type: 'dog',
    id: 'Cross-969',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Pinschelkhound',
    type: 'dog',
    id: 'Cross-970',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Miniature Schnaupin',
    type: 'dog',
    id: 'Cross-971',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Miniature Schnauzzie',
    type: 'dog',
    id: 'Cross-972',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Miniature Schnoxie',
    type: 'dog',
    id: 'Cross-973',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Miniboz',
    type: 'dog',
    id: 'Cross-974',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Minnie Jack',
    type: 'dog',
    id: 'Cross-975',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Minnie Parson',
    type: 'dog',
    id: 'Cross-976',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Morkie',
    type: 'dog',
    id: 'Cross-977',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Morkshire Terrier',
    type: 'dog',
    id: 'Cross-978',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mountain Bulldog',
    type: 'dog',
    id: 'Cross-979',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Mountain Cur Shepherd',
    type: 'dog',
    id: 'Cross-980',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Mountain Jack Cur',
    type: 'dog',
    id: 'Cross-981',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Mountain Mastiff',
    type: 'dog',
    id: 'Cross-982',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Muggin',
    type: 'dog',
    id: 'Cross-983',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Muscle Mastiff',
    type: 'dog',
    id: 'Cross-984',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Native American Newfie',
    type: 'dog',
    id: 'Cross-985',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Native American Shepherd',
    type: 'dog',
    id: 'Cross-986',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Native American Village Dog',
    type: 'dog',
    id: 'Cross-987',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Neahond',
    type: 'dog',
    id: 'Cross-988',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Neapolitan Shepherd',
    type: 'dog',
    id: 'Cross-989',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Neapolitan Boxer',
    type: 'dog',
    id: 'Cross-990',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Nekita',
    type: 'dog',
    id: 'Cross-991',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Neo Bullmastiff',
    type: 'dog',
    id: 'Cross-992',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Neo Daniff',
    type: 'dog',
    id: 'Cross-993',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'New Labralound',
    type: 'dog',
    id: 'Cross-994',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'New Rottland',
    type: 'dog',
    id: 'Cross-995',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'New Shep',
    type: 'dog',
    id: 'Cross-996',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Newfie Dane',
    type: 'dog',
    id: 'Cross-997',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Newfypoo',
    type: 'dog',
    id: 'Cross-998',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Norjack',
    type: 'dog',
    id: 'Cross-999',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Nortese',
    type: 'dog',
    id: 'Cross-1000',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Norwich de Tulear',
    type: 'dog',
    id: 'Cross-1001',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Old Anglican Bulldogge',
    type: 'dog',
    id: 'Cross-1002',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Old Deerhound Sheepdog',
    type: 'dog',
    id: 'Cross-1003',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Old Doxie Sheepdog',
    type: 'dog',
    id: 'Cross-1004',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Olde Boston Bullchi',
    type: 'dog',
    id: 'Cross-1005',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Olde Double Bully',
    type: 'dog',
    id: 'Cross-1006',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Olde Pit Bulldogge',
    type: 'dog',
    id: 'Cross-1007',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Olde Staff Bulldogge',
    type: 'dog',
    id: 'Cross-1008',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Olde Staffybull Bulldogge',
    type: 'dog',
    id: 'Cross-1009',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Ori Pei',
    type: 'dog',
    id: 'Cross-1010',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papastzu',
    type: 'dog',
    id: 'Cross-1011',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papeagle',
    type: 'dog',
    id: 'Cross-1012',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Paperanian',
    type: 'dog',
    id: 'Cross-1013',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papi-Inu',
    type: 'dog',
    id: 'Cross-1014',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Papi-poo',
    type: 'dog',
    id: 'Cross-1015',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papichon',
    type: 'dog',
    id: 'Cross-1016',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papigriffon',
    type: 'dog',
    id: 'Cross-1017',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papijack',
    type: 'dog',
    id: 'Cross-1018',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Papimo',
    type: 'dog',
    id: 'Cross-1019',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papiox',
    type: 'dog',
    id: 'Cross-1020',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papitese',
    type: 'dog',
    id: 'Cross-1021',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Papshund',
    type: 'dog',
    id: 'Cross-1022',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Parsonhund',
    type: 'dog',
    id: 'Cross-1023',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Patterdale Doxie',
    type: 'dog',
    id: 'Cross-1024',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Patterdale Shepherd',
    type: 'dog',
    id: 'Cross-1025',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Patterbea',
    type: 'dog',
    id: 'Cross-1026',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Patterjack',
    type: 'dog',
    id: 'Cross-1027',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Patterland',
    type: 'dog',
    id: 'Cross-1028',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Patton Terrier',
    type: 'dog',
    id: 'Cross-1029',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peagle',
    type: 'dog',
    id: 'Cross-1030',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peek-A-Pom',
    type: 'dog',
    id: 'Cross-1031',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pek-A-Rat',
    type: 'dog',
    id: 'Cross-1032',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pekalier',
    type: 'dog',
    id: 'Cross-1033',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pekarin',
    type: 'dog',
    id: 'Cross-1034',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-A-Boo',
    type: 'dog',
    id: 'Cross-1035',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-A-Chon',
    type: 'dog',
    id: 'Cross-1036',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Peke-A-Chow',
    type: 'dog',
    id: 'Cross-1037',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-A-Jack',
    type: 'dog',
    id: 'Cross-1038',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-A-Pap',
    type: 'dog',
    id: 'Cross-1039',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-A-Pin',
    type: 'dog',
    id: 'Cross-1040',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-A-Tese',
    type: 'dog',
    id: 'Cross-1041',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peka-A-West',
    type: 'dog',
    id: 'Cross-1042',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Peke-Italian',
    type: 'dog',
    id: 'Cross-1043',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pekehund',
    type: 'dog',
    id: 'Cross-1044',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pekepoo',
    type: 'dog',
    id: 'Cross-1045',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Pembroke Cocker Corgi',
    type: 'dog',
    id: 'Cross-1046',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pembroke Corgi Pointer',
    type: 'dog',
    id: 'Cross-1047',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pembroke Corman Shepherd',
    type: 'dog',
    id: 'Cross-1048',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pembroke Corswiss',
    type: 'dog',
    id: 'Cross-1049',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Pembroke Sheltie',
    type: 'dog',
    id: 'Cross-1050',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Petite Goldendoodle',
    type: 'dog',
    id: 'Cross-1051',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Petite Golden Retriever',
    type: 'dog',
    id: 'Cross-1052',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Petite Labradoodle',
    type: 'dog',
    id: 'Cross-1053',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pharaoh Lab',
    type: 'dog',
    id: 'Cross-1054',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Plica',
    type: 'dog',
    id: 'Cross-1055',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Plotkita',
    type: 'dog',
    id: 'Cross-1056',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Plottahoula',
    type: 'dog',
    id: 'Cross-1057',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Plott Rottie',
    type: 'dog',
    id: 'Cross-1058',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Plott Walker',
    type: 'dog',
    id: 'Cross-1059',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Plush Danois',
    type: 'dog',
    id: 'Cross-1060',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pin-Tzu',
    type: 'dog',
    id: 'Cross-1061',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pineranian',
    type: 'dog',
    id: 'Cross-1062',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pinny-Poo',
    type: 'dog',
    id: 'Cross-1063',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pinweiler',
    type: 'dog',
    id: 'Cross-1064',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pit Boodle',
    type: 'dog',
    id: 'Cross-1065',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pit Bullmastiff',
    type: 'dog',
    id: 'Cross-1066',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pit Heeler',
    type: 'dog',
    id: 'Cross-1067',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pit Pei',
    type: 'dog',
    id: 'Cross-1068',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pit Pin',
    type: 'dog',
    id: 'Cross-1069',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pitchow',
    type: 'dog',
    id: 'Cross-1070',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pitsky',
    type: 'dog',
    id: 'Cross-1071',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pitweiler',
    type: 'dog',
    id: 'Cross-1072',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pocket Pitbull',
    type: 'dog',
    id: 'Cross-1073',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pointer Bay',
    type: 'dog',
    id: 'Cross-1074',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pointer Pit',
    type: 'dog',
    id: 'Cross-1075',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pointollie',
    type: 'dog',
    id: 'Cross-1076',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Pom-Kee',
    type: 'dog',
    id: 'Cross-1077',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pom-A-Nauze',
    type: 'dog',
    id: 'Cross-1078',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pom-A-Pug',
    type: 'dog',
    id: 'Cross-1079',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pom-Coton',
    type: 'dog',
    id: 'Cross-1080',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pom-Shi',
    type: 'dog',
    id: 'Cross-1081',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pom-Silk',
    type: 'dog',
    id: 'Cross-1082',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pom Terrier',
    type: 'dog',
    id: 'Cross-1083',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pomapoo',
    type: 'dog',
    id: 'Cross-1084',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pomchi',
    type: 'dog',
    id: 'Cross-1085',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pomeagle',
    type: 'dog',
    id: 'Cross-1086',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pomerat',
    type: 'dog',
    id: 'Cross-1087',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Pomimo',
    type: 'dog',
    id: 'Cross-1088',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pomsky',
    type: 'dog',
    id: 'Cross-1089',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pomston',
    type: 'dog',
    id: 'Cross-1090',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Poo-Shi',
    type: 'dog',
    id: 'Cross-1091',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Poo-Ton',
    type: 'dog',
    id: 'Cross-1092',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pooahoula',
    type: 'dog',
    id: 'Cross-1093',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Poochin',
    type: 'dog',
    id: 'Cross-1094',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pooda Houla',
    type: 'dog',
    id: 'Cross-1095',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Poogle',
    type: 'dog',
    id: 'Cross-1096',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Poolky',
    type: 'dog',
    id: 'Cross-1097',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pootalian',
    type: 'dog',
    id: 'Cross-1098',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Poovanese',
    type: 'dog',
    id: 'Cross-1099',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Poshies',
    type: 'dog',
    id: 'Cross-1100',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Powderpap',
    type: 'dog',
    id: 'Cross-1101',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Presa Bulldog',
    type: 'dog',
    id: 'Cross-1102',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Presa Dane',
    type: 'dog',
    id: 'Cross-1103',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Pug-A-Mo',
    type: 'dog',
    id: 'Cross-1104',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pug-Coton',
    type: 'dog',
    id: 'Cross-1105',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pug Pit',
    type: 'dog',
    id: 'Cross-1106',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pug Shiba',
    type: 'dog',
    id: 'Cross-1107',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pug-Zu',
    type: 'dog',
    id: 'Cross-1108',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pugador',
    type: 'dog',
    id: 'Cross-1109',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugairn',
    type: 'dog',
    id: 'Cross-1110',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugalier',
    type: 'dog',
    id: 'Cross-1111',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Puganese',
    type: 'dog',
    id: 'Cross-1112',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pugapoo',
    type: 'dog',
    id: 'Cross-1113',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugese',
    type: 'dog',
    id: 'Cross-1114',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Puggat',
    type: 'dog',
    id: 'Cross-1115',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Puggit',
    type: 'dog',
    id: 'Cross-1116',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Puggle',
    type: 'dog',
    id: 'Cross-1117',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pughasa',
    type: 'dog',
    id: 'Cross-1118',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugillon',
    type: 'dog',
    id: 'Cross-1119',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Puginese',
    type: 'dog',
    id: 'Cross-1120',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugland',
    type: 'dog',
    id: 'Cross-1121',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugottie',
    type: 'dog',
    id: 'Cross-1122',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Pugmatian',
    type: 'dog',
    id: 'Cross-1123',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugshire',
    type: 'dog',
    id: 'Cross-1124',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pugwich',
    type: 'dog',
    id: 'Cross-1125',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Pushon',
    type: 'dog',
    id: 'Cross-1126',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pyredoodle',
    type: 'dog',
    id: 'Cross-1127',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pyrenees Husky',
    type: 'dog',
    id: 'Cross-1128',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pyrenees Pit',
    type: 'dog',
    id: 'Cross-1129',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Pyrador',
    type: 'dog',
    id: 'Cross-1130',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Raggle',
    type: 'dog',
    id: 'Cross-1131',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rashon',
    type: 'dog',
    id: 'Cross-1132',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Rat-A-Pap',
    type: 'dog',
    id: 'Cross-1133',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat Apso',
    type: 'dog',
    id: 'Cross-1134',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat Basset',
    type: 'dog',
    id: 'Cross-1135',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat-Cha',
    type: 'dog',
    id: 'Cross-1136',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat Feist',
    type: 'dog',
    id: 'Cross-1137',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat Heeler',
    type: 'dog',
    id: 'Cross-1138',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat Pei',
    type: 'dog',
    id: 'Cross-1139',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rat Pinscher',
    type: 'dog',
    id: 'Cross-1140',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Ratahoula',
    type: 'dog',
    id: 'Cross-1141',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Ratese',
    type: 'dog',
    id: 'Cross-1142',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Ratshi Terrier',
    type: 'dog',
    id: 'Cross-1143',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Ratshire Terrier',
    type: 'dog',
    id: 'Cross-1144',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rattle',
    type: 'dog',
    id: 'Cross-1145',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rattle Griffon',
    type: 'dog',
    id: 'Cross-1146',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Reagle',
    type: 'dog',
    id: 'Cross-1147',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Redbone Coonoodle',
    type: 'dog',
    id: 'Cross-1148',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Redbone Lab',
    type: 'dog',
    id: 'Cross-1149',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Redbone Shepherd',
    type: 'dog',
    id: 'Cross-1150',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Beagle',
    type: 'dog',
    id: 'Cross-1151',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Bernard',
    type: 'dog',
    id: 'Cross-1152',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Boxer',
    type: 'dog',
    id: 'Cross-1153',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Labrador',
    type: 'dog',
    id: 'Cross-1154',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rhodesian Pit',
    type: 'dog',
    id: 'Cross-1155',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Rottie',
    type: 'dog',
    id: 'Cross-1156',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Shepherd',
    type: 'dog',
    id: 'Cross-1157',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rhodesian Whippet',
    type: 'dog',
    id: 'Cross-1158',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rott Pei',
    type: 'dog',
    id: 'Cross-1159',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottaf',
    type: 'dog',
    id: 'Cross-1160',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottbull',
    type: 'dog',
    id: 'Cross-1161',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rotterman',
    type: 'dog',
    id: 'Cross-1162',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Rotticorso',
    type: 'dog',
    id: 'Cross-1163',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Basset',
    type: 'dog',
    id: 'Cross-1164',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Bordeaux',
    type: 'dog',
    id: 'Cross-1165',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Chow',
    type: 'dog',
    id: 'Cross-1166',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Cocker',
    type: 'dog',
    id: 'Cross-1167',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Corgi',
    type: 'dog',
    id: 'Cross-1168',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Heeler',
    type: 'dog',
    id: 'Cross-1169',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottie Shepherd',
    type: 'dog',
    id: 'Cross-1170',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottle',
    type: 'dog',
    id: 'Cross-1171',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottmatian',
    type: 'dog',
    id: 'Cross-1172',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottpeake',
    type: 'dog',
    id: 'Cross-1173',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rottsky',
    type: 'dog',
    id: 'Cross-1174',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rough Rhodesian Collie',
    type: 'dog',
    id: 'Cross-1175',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Rus-A-Pei',
    type: 'dog',
    id: 'Cross-1176',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Russian Doodle Terrier',
    type: 'dog',
    id: 'Cross-1177',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Rustralian Terrier',
    type: 'dog',
    id: 'Cross-1178',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Bernese',
    type: 'dog',
    id: 'Cross-1179',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Berdoodle',
    type: 'dog',
    id: 'Cross-1180',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Bermastiff',
    type: 'dog',
    id: 'Cross-1181',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Bernewfie',
    type: 'dog',
    id: 'Cross-1182',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Berxer',
    type: 'dog',
    id: 'Cross-1183',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Chesa Bay Bernard',
    type: 'dog',
    id: 'Cross-1184',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Dane',
    type: 'dog',
    id: 'Cross-1185',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Saint Pyrenees',
    type: 'dog',
    id: 'Cross-1186',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saint Shepherd',
    type: 'dog',
    id: 'Cross-1187',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saluki Greyhound',
    type: 'dog',
    id: 'Cross-1188',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saluki Deerhound',
    type: 'dog',
    id: 'Cross-1189',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Saluki Sloughi',
    type: 'dog',
    id: 'Cross-1190',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sammy Chow',
    type: 'dog',
    id: 'Cross-1191',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sammy Shepherd',
    type: 'dog',
    id: 'Cross-1192',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sammypoo',
    type: 'dog',
    id: 'Cross-1193',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Samollie',
    type: 'dog',
    id: 'Cross-1194',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Samusky',
    type: 'dog',
    id: 'Cross-1195',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sceagle',
    type: 'dog',
    id: 'Cross-1196',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schapso',
    type: 'dog',
    id: 'Cross-1197',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schip-A-Pom',
    type: 'dog',
    id: 'Cross-1198',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schip Coton',
    type: 'dog',
    id: 'Cross-1199',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schipese',
    type: 'dog',
    id: 'Cross-1200',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schipper-Chi',
    type: 'dog',
    id: 'Cross-1201',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Schipper Geraussie Shepherd',
    type: 'dog',
    id: 'Cross-1202',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schipper-Pin',
    type: 'dog',
    id: 'Cross-1203',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Schipper-Poo',
    type: 'dog',
    id: 'Cross-1204',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Schnairedale',
    type: 'dog',
    id: 'Cross-1205',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schnau-Tzu',
    type: 'dog',
    id: 'Cross-1206',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schnauffen',
    type: 'dog',
    id: 'Cross-1207',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Schnauzador',
    type: 'dog',
    id: 'Cross-1208',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Schnauzer Pit',
    type: 'dog',
    id: 'Cross-1209',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schneagle',
    type: 'dog',
    id: 'Cross-1210',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schnekingese',
    type: 'dog',
    id: 'Cross-1211',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schnese',
    type: 'dog',
    id: 'Cross-1212',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Schnocker',
    type: 'dog',
    id: 'Cross-1213',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Schnoodle',
    type: 'dog',
    id: 'Cross-1214',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Schnorgi',
    type: 'dog',
    id: 'Cross-1215',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Schnottie',
    type: 'dog',
    id: 'Cross-1216',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schnu',
    type: 'dog',
    id: 'Cross-1217',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schnug',
    type: 'dog',
    id: 'Cross-1218',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Schweenie',
    type: 'dog',
    id: 'Cross-1219',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sco-Shi',
    type: 'dog',
    id: 'Cross-1220',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scobo Terrier',
    type: 'dog',
    id: 'Cross-1221',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scoland Terrier',
    type: 'dog',
    id: 'Cross-1222',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Scolden Terrier',
    type: 'dog',
    id: 'Cross-1223',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scorkie',
    type: 'dog',
    id: 'Cross-1224',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scotchi',
    type: 'dog',
    id: 'Cross-1225',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scotchon',
    type: 'dog',
    id: 'Cross-1226',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scotinese',
    type: 'dog',
    id: 'Cross-1227',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scottese',
    type: 'dog',
    id: 'Cross-1228',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scotti Apso',
    type: 'dog',
    id: 'Cross-1229',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scottie Schnauzer',
    type: 'dog',
    id: 'Cross-1230',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Scottish Cocker',
    type: 'dog',
    id: 'Cross-1231',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Scottish Deer Greyhound',
    type: 'dog',
    id: 'Cross-1232',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Scottish-Skye Terrier',
    type: 'dog',
    id: 'Cross-1233',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Scottish Staffish Bull Terrier',
    type: 'dog',
    id: 'Cross-1234',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Scoodle',
    type: 'dog',
    id: 'Cross-1235',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sealydale Terrier',
    type: 'dog',
    id: 'Cross-1236',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shairn-Inu',
    type: 'dog',
    id: 'Cross-1237',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sharbo',
    type: 'dog',
    id: 'Cross-1238',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Shar-Pei Pitbull Terrier',
    type: 'dog',
    id: 'Cross-1239',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shar-Poo',
    type: 'dog',
    id: 'Cross-1240',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shar Tzu',
    type: 'dog',
    id: 'Cross-1241',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sharberian Husky',
    type: 'dog',
    id: 'Cross-1242',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sharmatian',
    type: 'dog',
    id: 'Cross-1243',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sharp Eagle',
    type: 'dog',
    id: 'Cross-1244',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sheepadoodle',
    type: 'dog',
    id: 'Cross-1245',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shel-Aussie',
    type: 'dog',
    id: 'Cross-1246',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shelchon',
    type: 'dog',
    id: 'Cross-1247',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shelestie',
    type: 'dog',
    id: 'Cross-1248',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shelillon',
    type: 'dog',
    id: 'Cross-1249',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sheltidoodle',
    type: 'dog',
    id: 'Cross-1250',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Sheltie Heeler',
    type: 'dog',
    id: 'Cross-1251',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sheltie Inu',
    type: 'dog',
    id: 'Cross-1252',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Sheltie-Kee',
    type: 'dog',
    id: 'Cross-1253',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sheltie Pin',
    type: 'dog',
    id: 'Cross-1254',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sheltie Pug',
    type: 'dog',
    id: 'Cross-1255',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sheltie Shepherd',
    type: 'dog',
    id: 'Cross-1256',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sheltie Tzu',
    type: 'dog',
    id: 'Cross-1257',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shepadoodle',
    type: 'dog',
    id: 'Cross-1258',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shepherd Pei',
    type: 'dog',
    id: 'Cross-1259',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Shepherd Pit',
    type: 'dog',
    id: 'Cross-1260',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shepherd Tzu',
    type: 'dog',
    id: 'Cross-1261',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Shepnees',
    type: 'dog',
    id: 'Cross-1262',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sheprador',
    type: 'dog',
    id: 'Cross-1263',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shepsky',
    type: 'dog',
    id: 'Cross-1264',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sheptese',
    type: 'dog',
    id: 'Cross-1265',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shepweiler',
    type: 'dog',
    id: 'Cross-1266',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shethund',
    type: 'dog',
    id: 'Cross-1267',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shetinese',
    type: 'dog',
    id: 'Cross-1268',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shi-Beagle',
    type: 'dog',
    id: 'Cross-1269',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shiba-Chi',
    type: 'dog',
    id: 'Cross-1270',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Shiba Corgi',
    type: 'dog',
    id: 'Cross-1271',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shiba Lab',
    type: 'dog',
    id: 'Cross-1272',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shiba Pin',
    type: 'dog',
    id: 'Cross-1273',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shibadox',
    type: 'dog',
    id: 'Cross-1274',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shibos',
    type: 'dog',
    id: 'Cross-1275',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'ShiChi',
    type: 'dog',
    id: 'Cross-1276',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shichon',
    type: 'dog',
    id: 'Cross-1277',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shiffon',
    type: 'dog',
    id: 'Cross-1278',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shih Apso',
    type: 'dog',
    id: 'Cross-1279',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Shih-Mo',
    type: 'dog',
    id: 'Cross-1280',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shih-Poo',
    type: 'dog',
    id: 'Cross-1281',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shinese',
    type: 'dog',
    id: 'Cross-1282',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shiranian',
    type: 'dog',
    id: 'Cross-1283',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Shocker',
    type: 'dog',
    id: 'Cross-1284',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Shockerd',
    type: 'dog',
    id: 'Cross-1285',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shollie',
    type: 'dog',
    id: 'Cross-1286',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Shorgi',
    type: 'dog',
    id: 'Cross-1287',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Shorkie Tzu',
    type: 'dog',
    id: 'Cross-1288',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Shug',
    type: 'dog',
    id: 'Cross-1289',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sibercaan',
    type: 'dog',
    id: 'Cross-1290',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Siberian Black Mouth Cur',
    type: 'dog',
    id: 'Cross-1291',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Boston',
    type: 'dog',
    id: 'Cross-1292',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Cocker',
    type: 'dog',
    id: 'Cross-1293',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Collisky',
    type: 'dog',
    id: 'Cross-1294',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Siberian Indian Dog',
    type: 'dog',
    id: 'Cross-1295',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Keeshond',
    type: 'dog',
    id: 'Cross-1296',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Kelpsky',
    type: 'dog',
    id: 'Cross-1297',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Pinscher',
    type: 'dog',
    id: 'Cross-1298',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Retriever',
    type: 'dog',
    id: 'Cross-1299',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberian Shiba',
    type: 'dog',
    id: 'Cross-1300',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Siberpoo',
    type: 'dog',
    id: 'Cross-1301',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkchon',
    type: 'dog',
    id: 'Cross-1302',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkese',
    type: 'dog',
    id: 'Cross-1303',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkin',
    type: 'dog',
    id: 'Cross-1304',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkinese',
    type: 'dog',
    id: 'Cross-1305',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkland Terrier',
    type: 'dog',
    id: 'Cross-1306',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkshire Terrier',
    type: 'dog',
    id: 'Cross-1307',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkshund',
    type: 'dog',
    id: 'Cross-1308',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky Cairn',
    type: 'dog',
    id: 'Cross-1309',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Silky Cocker',
    type: 'dog',
    id: 'Cross-1310',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky Coton',
    type: 'dog',
    id: 'Cross-1311',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky Jack',
    type: 'dog',
    id: 'Cross-1312',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky-Lhasa',
    type: 'dog',
    id: 'Cross-1313',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky-Pin',
    type: 'dog',
    id: 'Cross-1314',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky Pug',
    type: 'dog',
    id: 'Cross-1315',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silky Tzu',
    type: 'dog',
    id: 'Cross-1316',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkyhuahua',
    type: 'dog',
    id: 'Cross-1317',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkytie',
    type: 'dog',
    id: 'Cross-1318',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Silkzer',
    type: 'dog',
    id: 'Cross-1319',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Ski-Border',
    type: 'dog',
    id: 'Cross-1320',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Ski-Collie',
    type: 'dog',
    id: 'Cross-1321',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Skilky Terrier',
    type: 'dog',
    id: 'Cross-1322',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Skip-Shzu',
    type: 'dog',
    id: 'Cross-1323',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Skye-Pap',
    type: 'dog',
    id: 'Cross-1324',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Skypoo',
    type: 'dog',
    id: 'Cross-1325',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Chisoxy',
    type: 'dog',
    id: 'Cross-1326',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Fo-Chon',
    type: 'dog',
    id: 'Cross-1327',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Fo-Tzu',
    type: 'dog',
    id: 'Cross-1328',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Smooth Foodle',
    type: 'dog',
    id: 'Cross-1329',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Fox Beagle',
    type: 'dog',
    id: 'Cross-1330',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Fox Pinscher',
    type: 'dog',
    id: 'Cross-1331',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Foxie Doxie',
    type: 'dog',
    id: 'Cross-1332',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Foxingese',
    type: 'dog',
    id: 'Cross-1333',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Smooth Foxker',
    type: 'dog',
    id: 'Cross-1334',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Foxillon',
    type: 'dog',
    id: 'Cross-1335',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Foxton',
    type: 'dog',
    id: 'Cross-1336',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Smooth Foxy Boerboel',
    type: 'dog',
    id: 'Cross-1337',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Foxy Rat Terrier',
    type: 'dog',
    id: 'Cross-1338',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Foxy Russell',
    type: 'dog',
    id: 'Cross-1339',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Smooth Foxybull Terrier',
    type: 'dog',
    id: 'Cross-1340',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Jafox',
    type: 'dog',
    id: 'Cross-1341',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Toy Foxter',
    type: 'dog',
    id: 'Cross-1342',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Pom Terrier',
    type: 'dog',
    id: 'Cross-1343',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Poxer',
    type: 'dog',
    id: 'Cross-1344',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Smooth Rhodesian Collie',
    type: 'dog',
    id: 'Cross-1345',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Scottish Fox Terrier',
    type: 'dog',
    id: 'Cross-1346',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Smooth Torkie',
    type: 'dog',
    id: 'Cross-1347',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Sniffon',
    type: 'dog',
    id: 'Cross-1348',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Snorkie',
    type: 'dog',
    id: 'Cross-1349',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Soft Coated Golden',
    type: 'dog',
    id: 'Cross-1350',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Soft Coated Wheatzer',
    type: 'dog',
    id: 'Cross-1351',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Soft Coated Woxer',
    type: 'dog',
    id: 'Cross-1352',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Spanador',
    type: 'dog',
    id: 'Cross-1353',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Spangold Retriever',
    type: 'dog',
    id: 'Cross-1354',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Spanierd',
    type: 'dog',
    id: 'Cross-1355',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Spantriever',
    type: 'dog',
    id: 'Cross-1356',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Spreagle',
    type: 'dog',
    id: 'Cross-1357',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Springer Basset',
    type: 'dog',
    id: 'Cross-1358',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Springer Husky',
    type: 'dog',
    id: 'Cross-1359',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Springer Pit',
    type: 'dog',
    id: 'Cross-1360',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Springer Rottie',
    type: 'dog',
    id: 'Cross-1361',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Springer Spaniel Sheepdog',
    type: 'dog',
    id: 'Cross-1362',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Springerdoodle',
    type: 'dog',
    id: 'Cross-1363',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sprocker Spaniel',
    type: 'dog',
    id: 'Cross-1364',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Sprollie',
    type: 'dog',
    id: 'Cross-1365',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Staffy Bull Bordeaux',
    type: 'dog',
    id: 'Cross-1366',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Staffy Bull Bullmastiff',
    type: 'dog',
    id: 'Cross-1367',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Staffweiler',
    type: 'dog',
    id: 'Cross-1368',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'St. Weiler',
    type: 'dog',
    id: 'Cross-1369',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Staffie Bullweiler',
    type: 'dog',
    id: 'Cross-1370',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Staffy Bull Pei',
    type: 'dog',
    id: 'Cross-1371',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Staffy Bull Pit',
    type: 'dog',
    id: 'Cross-1372',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Staffy Bull Pug',
    type: 'dog',
    id: 'Cross-1373',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Staffy Bull Wolfhound',
    type: 'dog',
    id: 'Cross-1374',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Staffy Heeler',
    type: 'dog',
    id: 'Cross-1375',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Staffy Pit',
    type: 'dog',
    id: 'Cross-1376',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Standard Auss-Tzu',
    type: 'dog',
    id: 'Cross-1377',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Standard Bolonauzer',
    type: 'dog',
    id: 'Cross-1378',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Standard Border Schnollie',
    type: 'dog',
    id: 'Cross-1379',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Standard Chesa-Poo',
    type: 'dog',
    id: 'Cross-1380',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Standard Gordondoodle',
    type: 'dog',
    id: 'Cross-1381',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Standard Irish Wolf Schnauzer',
    type: 'dog',
    id: 'Cross-1382',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Standard Kerry Blue Schnauzer',
    type: 'dog',
    id: 'Cross-1383',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Standard Ratzer',
    type: 'dog',
    id: 'Cross-1384',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Standard Schnauzer Chin',
    type: 'dog',
    id: 'Cross-1385',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Standard Schnoodle',
    type: 'dog',
    id: 'Cross-1386',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Standard Siberian Schusky',
    type: 'dog',
    id: 'Cross-1387',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Standard Wauzer',
    type: 'dog',
    id: 'Cross-1388',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Standard Wire Hair Snauzer',
    type: 'dog',
    id: 'Cross-1389',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Stump Double Cattle Dog',
    type: 'dog',
    id: 'Cross-1390',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Swiss Bernese Mt. Dog',
    type: 'dog',
    id: 'Cross-1391',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Swiss Newfie',
    type: 'dog',
    id: 'Cross-1392',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Swissy Saint',
    type: 'dog',
    id: 'Cross-1393',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Swissneese',
    type: 'dog',
    id: 'Cross-1394',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Taco Terrier',
    type: 'dog',
    id: 'Cross-1395',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: `Taylor's Bulldane`,
    type: 'dog',
    id: 'Cross-1396',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Terri-Poo',
    type: 'dog',
    id: 'Cross-1397',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Tervard',
    type: 'dog',
    id: 'Cross-1398',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Tervoodle',
    type: 'dog',
    id: 'Cross-1399',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Texas Heeler',
    type: 'dog',
    id: 'Cross-1400',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Thai Boxridge',
    type: 'dog',
    id: 'Cross-1401',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Tibalier',
    type: 'dog',
    id: 'Cross-1402',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Tibecot',
    type: 'dog',
    id: 'Cross-1403',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Tibepillon Terrier',
    type: 'dog',
    id: 'Cross-1404',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Tibetan Chin',
    type: 'dog',
    id: 'Cross-1405',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Tibetan Golden Mastiff',
    type: 'dog',
    id: 'Cross-1406',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Tibetan Pap',
    type: 'dog',
    id: 'Cross-1407',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Tibetan Pom',
    type: 'dog',
    id: 'Cross-1408',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Tibetan Pug',
    type: 'dog',
    id: 'Cross-1409',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Tibetan Spaltese',
    type: 'dog',
    id: 'Cross-1410',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Tibetan Wolfhound',
    type: 'dog',
    id: 'Cross-1411',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Tibetanpei Spaniel',
    type: 'dog',
    id: 'Cross-1412',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Tibetan Staffy Spaniel',
    type: 'dog',
    id: 'Cross-1413',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Toller Pit',
    type: 'dog',
    id: 'Cross-1414',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Torkie',
    type: 'dog',
    id: 'Cross-1415',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Tosa-Pei',
    type: 'dog',
    id: 'Cross-1416',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toxirn',
    type: 'dog',
    id: 'Cross-1417',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Chisoxy',
    type: 'dog',
    id: 'Cross-1418',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Fo-Chon',
    type: 'dog',
    id: 'Cross-1419',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Fo-Tzu',
    type: 'dog',
    id: 'Cross-1420',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Toy Foodle',
    type: 'dog',
    id: 'Cross-1421',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Fox Beagle',
    type: 'dog',
    id: 'Cross-1422',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Fox Pinscher',
    type: 'dog',
    id: 'Cross-1423',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Foxie Doxie',
    type: 'dog',
    id: 'Cross-1424',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Foxillon',
    type: 'dog',
    id: 'Cross-1425',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Foxingese',
    type: 'dog',
    id: 'Cross-1426',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Toy Foxker',
    type: 'dog',
    id: 'Cross-1427',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Foxton',
    type: 'dog',
    id: 'Cross-1428',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Foxy Rat Terrier',
    type: 'dog',
    id: 'Cross-1429',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Foxy Russell',
    type: 'dog',
    id: 'Cross-1430',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Toy Foxybull Terrier',
    type: 'dog',
    id: 'Cross-1431',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Toy Gordondoodle',
    type: 'dog',
    id: 'Cross-1432',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Jafox',
    type: 'dog',
    id: 'Cross-1433',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Pom Terrier',
    type: 'dog',
    id: 'Cross-1434',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Poxer',
    type: 'dog',
    id: 'Cross-1435',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Toy Rat Doxie',
    type: 'dog',
    id: 'Cross-1436',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Scottish Fox Terrier',
    type: 'dog',
    id: 'Cross-1437',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Toy Torkie',
    type: 'dog',
    id: 'Cross-1438',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Transylvizsla Hound',
    type: 'dog',
    id: 'Cross-1439',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Treeing Walker Coonoodle',
    type: 'dog',
    id: 'Cross-1440',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Tsvetnaya Blonka-Poo',
    type: 'dog',
    id: 'Cross-1441',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Ttoodle',
    type: 'dog',
    id: 'Cross-1442',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Tzu Basset',
    type: 'dog',
    id: 'Cross-1443',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Ultimate Mastiff',
    type: 'dog',
    id: 'Cross-1444',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Vizmaraner',
    type: 'dog',
    id: 'Cross-1445',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Vizsla Pin',
    type: 'dog',
    id: 'Cross-1446',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Vizsla Staff',
    type: 'dog',
    id: 'Cross-1447',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Walker Beagle',
    type: 'dog',
    id: 'Cross-1448',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Walker Greyhound',
    type: 'dog',
    id: 'Cross-1449',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wauzer',
    type: 'dog',
    id: 'Cross-1450',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wee-Chon',
    type: 'dog',
    id: 'Cross-1451',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Weeranian',
    type: 'dog',
    id: 'Cross-1452',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weiler Dane',
    type: 'dog',
    id: 'Cross-1453',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weim-Pei',
    type: 'dog',
    id: 'Cross-1454',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weimapeake',
    type: 'dog',
    id: 'Cross-1455',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weimardale',
    type: 'dog',
    id: 'Cross-1456',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weimardoodle',
    type: 'dog',
    id: 'Cross-1457',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weimarman',
    type: 'dog',
    id: 'Cross-1458',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weimarrott',
    type: 'dog',
    id: 'Cross-1459',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weimshepherd',
    type: 'dog',
    id: 'Cross-1460',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wel-Chon',
    type: 'dog',
    id: 'Cross-1461',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Welsh Mini Fox Terrier',
    type: 'dog',
    id: 'Cross-1462',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Welsh Smooth Fox Terrier',
    type: 'dog',
    id: 'Cross-1463',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Welsh Toy Fox Terrier',
    type: 'dog',
    id: 'Cross-1464',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Welsh Wire Fox Terrier',
    type: 'dog',
    id: 'Cross-1465',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Welshund',
    type: 'dog',
    id: 'Cross-1466',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Weltador',
    type: 'dog',
    id: 'Cross-1467',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Weshi',
    type: 'dog',
    id: 'Cross-1468',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'West Australian Terrier',
    type: 'dog',
    id: 'Cross-1469',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'West Highland Corgi',
    type: 'dog',
    id: 'Cross-1470',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'West Highland Doxie',
    type: 'dog',
    id: 'Cross-1471',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'West Highland Husky',
    type: 'dog',
    id: 'Cross-1472',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'West of Argyll Terrier',
    type: 'dog',
    id: 'Cross-1473',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Westeke',
    type: 'dog',
    id: 'Cross-1474',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Westie-Laso',
    type: 'dog',
    id: 'Cross-1475',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Westie Staff',
    type: 'dog',
    id: 'Cross-1476',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Westiepoo',
    type: 'dog',
    id: 'Cross-1477',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Westillon',
    type: 'dog',
    id: 'Cross-1478',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Westimo',
    type: 'dog',
    id: 'Cross-1479',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Weston',
    type: 'dog',
    id: 'Cross-1480',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wheagle',
    type: 'dog',
    id: 'Cross-1481',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wheatador',
    type: 'dog',
    id: 'Cross-1482',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Wheaten Eskimo',
    type: 'dog',
    id: 'Cross-1483',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wheaten Pei',
    type: 'dog',
    id: 'Cross-1484',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Whipador',
    type: 'dog',
    id: 'Cross-1485',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Whipperman',
    type: 'dog',
    id: 'Cross-1486',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Whippet Greyhound',
    type: 'dog',
    id: 'Cross-1487',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Whippet Shepherd',
    type: 'dog',
    id: 'Cross-1488',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Whoodle',
    type: 'dog',
    id: 'Cross-1489',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Chisoxy',
    type: 'dog',
    id: 'Cross-1490',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Fo-Chon',
    type: 'dog',
    id: 'Cross-1491',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Fo-Tzu',
    type: 'dog',
    id: 'Cross-1492',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wire Foodle',
    type: 'dog',
    id: 'Cross-1493',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Fox Beagle',
    type: 'dog',
    id: 'Cross-1494',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Fox Pinscher',
    type: 'dog',
    id: 'Cross-1495',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Foxie Doxie',
    type: 'dog',
    id: 'Cross-1496',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Foxingese',
    type: 'dog',
    id: 'Cross-1497',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Wire Foxker',
    type: 'dog',
    id: 'Cross-1498',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Foxton',
    type: 'dog',
    id: 'Cross-1499',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Foxy Rat Terrier',
    type: 'dog',
    id: 'Cross-1500',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Foxy Russell',
    type: 'dog',
    id: 'Cross-1501',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wire Foxybull Terrier',
    type: 'dog',
    id: 'Cross-1502',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Hair Snauzer',
    type: 'dog',
    id: 'Cross-1503',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Jafox',
    type: 'dog',
    id: 'Cross-1504',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Toy Foxter',
    type: 'dog',
    id: 'Cross-1505',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Pom Terrier',
    type: 'dog',
    id: 'Cross-1506',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Poxer',
    type: 'dog',
    id: 'Cross-1507',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wire-Poo',
    type: 'dog',
    id: 'Cross-1508',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Scottish Fox Terrier',
    type: 'dog',
    id: 'Cross-1509',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wire Torkie',
    type: 'dog',
    id: 'Cross-1510',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wirehaired Pointing Griffiondor',
    type: 'dog',
    id: 'Cross-1511',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wirelsh Terrier',
    type: 'dog',
    id: 'Cross-1512',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Wolador',
    type: 'dog',
    id: 'Cross-1513',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Wolamute',
    type: 'dog',
    id: 'Cross-1514',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: 'N/A',
    breedName: 'Wolfdog',
    type: 'dog',
    id: 'Cross-1515',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Wolfhound Dane',
    type: 'dog',
    id: 'Cross-1516',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Woodle',
    type: 'dog',
    id: 'Cross-1517',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '5',
    breedName: 'Worgi',
    type: 'dog',
    id: 'Cross-1518',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Wowauzer',
    type: 'dog',
    id: 'Cross-1519',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yoranian',
    type: 'dog',
    id: 'Cross-1520',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkeltie',
    type: 'dog',
    id: 'Cross-1521',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkie-Apso',
    type: 'dog',
    id: 'Cross-1522',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkie Beagle',
    type: 'dog',
    id: 'Cross-1523',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkie Pin',
    type: 'dog',
    id: 'Cross-1524',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkie Russell',
    type: 'dog',
    id: 'Cross-1525',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkie-ton',
    type: 'dog',
    id: 'Cross-1526',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkillon',
    type: 'dog',
    id: 'Cross-1527',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Yorkipoo',
    type: 'dog',
    id: 'Cross-1528',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorkinese',
    type: 'dog',
    id: 'Cross-1529',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '6',
    breedName: 'Yorksky',
    type: 'dog',
    id: 'Cross-1530',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorktese',
    type: 'dog',
    id: 'Cross-1531',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Yorwich',
    type: 'dog',
    id: 'Cross-1532',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '4',
    breedName: 'Zuchon',
    type: 'dog',
    id: 'Cross-1533',
    isCrossBreed: true,
  },
  {
    aliasToBreedId: '221',
    breedName: 'Maltipoo',
    type: 'dog',
    id: 'Cross-1534',
    isCrossBreed: true,
  },
];
